export default {
  fu: {
    search_bar: {
      search: '搜索',
      adv_search: '高級搜索',
      ok: '確定',
      cancel: '取消',
      please_select: '請選擇',
      please_input: '請輸入',
      like: '包含',
      not_like: '不包含',
      in: '屬於',
      not_in: '不屬於',
      gt: '大於',
      ge: '大於等於',
      lt: '小於',
      le: '小於等於',
      eq: '等於',
      ne: '不等於',
      between: '之間',
      select_date: '選擇日期',
      start_date: '開始日期',
      end_date: '結束日期',
      select_date_time: '選擇日期時間',
      start_date_time: '開始日期時間',
      end_date_time: '結束日期時間',
      range_separator: '至',
      data_time_error: '開始日期不能大於結束日期',
      clean: '清空',
      refresh: '刷新'
    },
    table: {
      ok: '確定',
      custom_table_fields: '自定義表格字段',
      custom_table_fields_desc: '固定字段不在選擇範圍'
    },
    steps: {
      cancel: '取消',
      next: '下一步',
      prev: '上一步',
      finish: '完成'
    }
  },
  track: {
    upload_limit_format: '圖片格式錯誤，支持JPG，PNG',
    upload_limit_size: '圖片大小不超過'
  },
  route: {
    dashboard: '首頁',
    documentation: '文檔',
    guide: '引導頁',
    permission: '權限測試頁',
    rolePermission: '角色權限',
    pagePermission: '頁面權限',
    directivePermission: '指令權限',
    icons: '圖標',
    components: '組件',
    tinymce: '富文本編輯器',
    markdown: 'Markdown',
    jsonEditor: 'JSON 編輯器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '頭像上傳',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: '小組件',
    backToTop: '返回頂部',
    dragDialog: '拖拽 Dialog',
    dragSelect: '拖拽 Select',
    dragKanban: '可拖拽看闆',
    charts: '圖表',
    keyboardChart: '鍵盤圖表',
    lineChart: '摺線圖',
    mixChart: '混合圖表',
    example: '綜合實例',
    nested: '路由嵌套',
    menu1: '菜單1',
    'menu1-1': '菜單 1-1',
    'menu1-2': '菜單 1-2',
    'menu1-2-1': '菜單 1-2-1',
    'menu1-2-2': '菜單 1-2-2',
    'menu1-3': '菜單 1-3',
    menu2: '菜單 2',
    Table: 'Table',
    dynamicTable: '動態 Table',
    dragTable: '拖拽 Table',
    inlineEditTable: 'Table 內編輯',
    complexTable: '綜合 Table',
    tab: 'Tab',
    form: '表單',
    createArticle: '創建文章',
    editArticle: '編輯文章',
    articleList: '文章列表',
    errorPages: '錯誤頁面',
    page401: '401',
    page404: '404',
    errorLog: '錯誤日誌',
    excel: 'Excel',
    exportExcel: '導出 Excel',
    selectExcel: '導出 已選擇項',
    mergeHeader: '導出 多級表頭',
    uploadExcel: '上傳 Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: '換膚',
    clipboardDemo: 'Clipboard',
    i18n: '國際化',
    externalLink: '外鏈',
    profile: '個人中心'
  },
  navbar: {
    dashboard: '首頁',
    github: '項目地址',
    logOut: '退出登錄',
    profile: '個人中心',
    theme: '換膚',
    size: '佈局大小'
  },
  login: {
    title: '繫統登錄',
    welcome: '歡迎使用',
    logIn: '登錄',
    username: '賬號',
    password: '密碼',
    any: '隨便填',
    thirdparty: '第三方登錄',
    thirdpartyTips: '本地不能模擬，請結合自己業務進行模擬！！！',
    expires: '登錄信息過期，請重新登錄',
    tokenError: '登陸信息錯誤，請重新登錄',
    username_error: '請輸入正確的 ID',
    password_error: '密碼不小於 8 位',
    re_login: '重新登錄',
    default_login: '普通登錄'
  },
  commons: {
    consanguinity: '血緣關係',
    collapse_navigation: '收起導航',
    operate_cancelled: '已取消操作',
    bind: '綁定',
    unbind: '解綁',
    unlock: '解鎖',
    unlock_success: '解鎖成功',
    parameter_effect: '參數值僅在數据集編輯時生效',
    uninstall: '卸載',

    no_result: '沒有找到相關內容',
    manage_member: '管理成員',
    user_confirm_remove_cancel: '確定將該用戶從角色中移除嗎?',
    confirm_remove_cancel: '確定刪除該角色嗎?',
    default_value: '默認值',
    params_value: '參數值',
    publish: '發布',
    input_role_name: '請輸入角色名稱',
    unpublished: '取消發布',
    default_pwd: '初始密碼',
    stop: '停止',
    first_login_tips: '您使用的是初始密碼，記得修改密碼哦',
    roger_that: '知道了',
    donot_noti: '不再提示',
    apply: '應用',
    search: '搜索',
    folder: '目錄',
    no_target_permission: '沒有權限',
    success: '成功',
    switch_lang: '切換語言成功',
    close: '關閉',
    icon: '圖標',
    all: '全部',
    enable: '啓用',
    disable: '禁用',
    yes: '是',
    no: '否',
    reset: '重置',
    catalogue: '目錄',
    button: '按鈕',
    gender: '性別',
    man: '男',
    woman: '女',
    keep_secret: '保密',
    nick_name: '姓名',
    confirmPassword: '確認密碼',
    upload: '上傳',
    cover: '覆蓋',
    not_cover: '不覆蓋',
    import_mode: '導入模式',
    import_module: '導入模塊',
    please_fill_in_the_template: '請填寫模版內容',
    cut_back_old_version: '切回舊版',
    cut_back_new_version: '切回新版',
    comment: '評論',
    examples: '示例',
    help_documentation: '幫助文檔',
    api_help_documentation: 'API文檔',
    delete_cancelled: '已取消刪除',
    workspace: '工作空間',
    organization: '組織',
    menu: '菜單',
    setting: '設置',
    project: '項目',
    about_us: '關於',
    current_project: '當前項目',
    name: '名稱',
    description: '描述',
    annotation: '註釋',
    clear: '清空',
    save: '保存',
    otherSave: '另存為',
    update: '更新',
    save_success: '保存成功',
    delete_success: '刪除成功',
    copy_success: '複製成功',
    modify_success: '修改成功',
    delete_cancel: '已取消刪除',
    confirm: '確定',
    cancel: '取消',
    prompt: '提示',
    operating: '操作',
    input_limit: '長度在 {0} 到 {1} 個字符',
    login: '登錄',
    welcome: '一站式開源數據分析平臺',
    username: '姓名',
    password: '密碼',
    input_username: '請輸入用戶姓名',
    input_password: '請輸入密碼',
    test: '測試',
    create_time: '創建時間',
    update_time: '更新時間',
    add: '添加',
    member: '成員',
    email: '郵箱',
    phone: '電話',
    mobile_phone: '請輸入手機號',
    mobile_phone_number: '手機號碼',
    role: '角色',
    personal_info: '個人信息',
    api_keys: 'API Keys',
    quota: '配額管理',
    status: '狀態',
    show_all: '顯示全部',
    show: '顯示',
    report: '報告',
    user: '用戶',
    system: '繫統',
    personal_setting: '個人設置',
    test_resource_pool: '測試資源池',
    system_setting: '繫統設置',
    input_content: '請輸入內容',
    create: '新建',
    edit: '編輯',
    copy: '複製',
    refresh: '刷新',
    remark: '備註',
    delete: '刪除',
    reduction: '恢複',
    not_filled: '未填寫',
    please_select: '請選擇',
    search_by_name: '根據名稱搜索',
    personal_information: '個人信息',
    exit_system: '退出繫統',
    verification: '驗證',
    title: '標題',
    custom: '自定義',
    select_date: '選擇日期',
    months_1: '一月',
    months_2: '二月',
    months_3: '三月',
    months_4: '四月',
    months_5: '五月',
    months_6: '六月',
    months_7: '七月',
    months_8: '八月',
    months_9: '九月',
    months_10: '十月',
    months_11: '十一月',
    months_12: '十二月',
    weeks_0: '周日',
    weeks_1: '周一',
    weeks_2: '周二',
    weeks_3: '周三',
    weeks_4: '周四',
    weeks_5: '周五',
    weeks_6: '周六',
    system_parameter_setting: '繫統參數設置',
    connection_successful: '連接成功',
    connection_failed: '連接失敗',
    save_failed: '保存失敗',
    host_cannot_be_empty: '主機不能爲空',
    port_cannot_be_empty: '端口號不能爲空',
    account_cannot_be_empty: '帳戶不能爲空',
    remove: '移除',
    remove_cancel: '移除取消',
    remove_success: '移除成功',
    tips: '認證信息已過期，請重新登錄',
    not_performed_yet: '尚未執行',
    incorrect_input: '輸入內容不正確',
    delete_confirm: '請輸入以下內容，確認刪除：',
    login_username: 'ID 或 郵箱',
    input_login_username: '請輸入用戶 ID 或 郵箱',
    input_name: '請輸入名稱',
    please_upload: '請上傳文件',
    please_fill_path: '請填寫ur路徑',
    formatErr: '格式錯誤',
    please_save: '請先保存',
    reference_documentation: '參考文檔',
    id: 'ID',
    millisecond: '毫秒',
    cannot_be_null: '不能爲空',
    required: '必填',
    already_exists: '名稱不能重複',
    modifier: '修改人',
    validate: '校驗',
    batch_add: '批量添加',
    tag_tip: '輸入回車添加標簽',
    search_keywords: '輸入關鍵字搜索',
    table: {
      select_tip: '已選中 {0} 條數據'
    },
    date: {
      select_date: '選擇日期',
      start_date: '開始日期',
      end_date: '結束日期',
      select_date_time: '選擇日期時間',
      start_date_time: '開始日期時間',
      end_date_time: '結束日期時間',
      range_separator: '至',
      data_time_error: '開始日期不能大於結束日期',
      one_day: '一天',
      one_week: '一周',
      one_month: '一個月'
    },
    adv_search: {
      title: '高級搜索',
      combine: '組合查詢',
      test: '所屬測試',
      project: '所屬項目',
      search: '查詢',
      reset: '重置',
      and: '所有',
      or: '任意一個',
      operators: {
        is_empty: '空',
        is_not_empty: '非空',
        like: '包含',
        not_like: '不包含',
        in: '屬於',
        not_in: '不屬於',
        gt: '大於',
        ge: '大於等於',
        lt: '小於',
        le: '小於等於',
        equals: '等於',
        not_equals: '不等於',
        between: '之間',
        current_user: '是當前用戶'
      },
      message_box: {
        alert: '警告',
        confirm: '確認'
      }
    },
    monitor: '監控',
    image: '鏡像',
    tag: '標簽',
    module: {
      select_module: '選擇模塊',
      default_module: '默認模塊'
    },
    datasource: '數據源',
    char_can_not_more_50: '不能超過50字符',
    share_success: '分享成功',
    input_id: '請輸入ID',
    input_pwd: '請輸入密碼',
    message_box: {
      alert: '警告',
      confirm: '確認',
      ok: '確認',
      cancel: '取消'
    },
    ukey_title: 'API Keys',
    thumbnail: '縮略圖',
    confirm_delete: '確認刪除',
    delete_this_dashboard: '確認删除該儀錶板嗎?',
    confirm_stop: '確認停止',
    stop_success: '停止成功',
    treeselect: {
      no_children_text: '沒有子節點',
      no_options_text: '沒有可用選項',
      no_results_text: '沒有匹配的結果'
    }
  },
  documentation: {
    documentation: '文檔',
    github: 'Github 地址'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '編輯權限',
    roles: '妳的權限',
    switchRoles: '切換權限',
    tips: '在某些情況下，不適合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它動態渲染 dom 的場景。妳只能通過手動設置 v-if 來實現。',
    delete: '刪除',
    confirm: '確定',
    cancel: '取消'
  },
  guide: {
    description: '引導頁對於一些第一次進入項目的人很有用，妳可以簡單介紹下項目的功能。本 Demo 是基於',
    button: '打開引導'
  },
  components: {
    documentation: '文檔',
    tinymceTips: '富文本是管理後臺一個核心的功能，但同時又是一個有很多坑的地方。在選擇富文本的過程中我也走了不少的彎路，市面上常見的富文本都基本用過了，最終權衡了一下選擇了Tinymce。更詳細的富文本比較和介紹見',
    dropzoneTips: '由於我司業務有特殊需求，而且要傳七牛 所以沒用第三方，選擇了自己封裝。代碼非常的簡單，具體代碼妳可以在這裏看到 @/components/Dropzone',
    stickyTips: '當頁面滾動到預設的位置會吸附在頂部',
    backToTopTips1: '頁面滾動到指定位置會在右下角出現返回頂部按鈕',
    backToTopTips2: '可自定義按鈕的樣式、show/hide、出現的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由於我在使用時它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的話，優先還是使用官方版本。',
    run_once: '運行一次',
    continue: '繼續',
    hour: '小時',
    minute: '分鐘',
    day: '天',
    by_task_name: '通過任務名稱搜索',
    delete_this_task: '確定刪除該任務嗎？',
    all_read_successfully: '全部已讀成功全部已讀成功',
    message_receiving_management: '消息接收管理',
    upload_failed: '上傳失敗',
    is_not_supported: '檔案格式不支持',
    is_too_large: '檔案過大',
    enter_kettle_address: '請輸入Kettle地址',
    enter_the_port: '請輸入埠',
    one_user_name: '請輸入用戶名',
    input_a_password: '請輸入密碼',
    address_is_required: 'Kettle地址為必填',
    port_is_required: '埠為必填',
    name_is_required: '用戶名為必填',
    password_is_required: '密碼為必填',
    help_document_link: '幫助文檔連結無效',
    such_as_dataeasedataease: '請輸入登入頁面標題，比如：DataEase',
    for_example_dataease: '請輸入系統名稱，比如：DataEase',
    time_is_required: '開始時間為必填',
    it_takes_effect: '卸載並重啓服務器之後才能生效',
    uninstall_the_plugin: '確定卸載該挿件？',
    uninstall: '卸載',
    relevant_content_found: '沒有找到相關內容',
    view_tasks: '查看任務',
    no_classification: '暫無分類',
    no_template: '暫無模版',
    data_set_required: '數據集必填',
    unread_message: '未讀消息',
    read_message: '已讀消息',
    all_messages: '全部消息',
    message_list: '消息清單',
    by_plugin_name: '通過挿件名稱搜索',
    unable_to_uninstall: '內寘挿件，無法卸載',
    unable_to_update: '內寘挿件，無法更新',
    free: '免費',
    cost: '費用',
    developer: '開發者',
    edition: '版本',
    installation_time: '安裝時間'
  },
  table: {
    dynamicTips1: '固定表頭, 按照表頭順序排序',
    dynamicTips2: '不固定表頭, 按照點擊順序排序',
    dragTips1: '默認順序',
    dragTips2: '拖拽後順序',
    title: '標題',
    importance: '重要性',
    type: '類型',
    remark: '點評',
    search: '搜索',
    add: '添加',
    export: '導出',
    reviewer: '審核人',
    id: '序號',
    date: '時間',
    author: '作者',
    readings: '閱讀數',
    status: '狀態',
    actions: '操作',
    edit: '編輯',
    publish: '發佈',
    draft: '草稿',
    delete: '刪除',
    cancel: '取 消',
    confirm: '確 定'
  },
  deDataset: {
    search_by_name: '通過名稱搜索',
    new_folder: '新建資料夾',
    search_fields: '搜索欄位',
    show_rows: '顯示行數',
    display: '顯示',
    row: '行',
    restricted_objects: '受限對象',
    select_data_source: '選擇數據源',
    by_table_name: '通過表名稱搜索',
    run_a_query: '運行査詢',
    running_results: '運行結果',
    parameter_type: '參數類型',
    run_failed: '運行失敗',
    select_data_table: '選擇資料表',
    in_the_file: '檔案中不能存在合併儲存格',
    or_date_type: '檔案的第一行為標題行，不能為空，不能為日期型',
    is_within_500m: 'Excel文件大小請確保在500M以內',
    upload_data: '上傳數據',
    excel_data_first: '請先上傳Excel數據',
    is_currently_available: '當前無可用的資料表',
    sure_to_synchronize: '同步欄位可能導致已編輯欄位發生變更，確定同步？',
    folder_name: '資料夾名稱',
    folder: '所屬資料夾',
    edit_folder: '編輯資料夾',
    name_already_exists: '資料夾名稱已存在',
    data_preview: '數據預覽',
    original_name: '原始名稱',
    database: '資料庫',
    selected: '已選：',
    table: '表',
    no_dataset_click: '暫無數據集，點擊',
    create: '新建',
    new_folder_first: '請先新建資料夾',
    on_the_left: '請在左側選擇數據集',
    expression_syntax_error: '欄位運算式語法錯誤',
    create_dashboard: '創建儀表板',
    cannot_be_empty: 'SQL不能為空',
    data_reference: '數據參攷',
    want_to_replace: '替換可能會影響自定義數據集、關聯數據集、儀表板等，是否替換？',
    replace_the_data: '確定替換數據嗎？',
    append_successfully: '追加成功',
    already_exists: '數據集名稱已存在',
    edit_dataset: '編輯數據集',
    convert_to_indicator: '轉換為名額',
    convert_to_dimension: '轉換為維度',
    left_to_edit: '選中左側的資料表可進行編輯',
    cannot_be_duplicate: '數據集名稱不允許重複',
    set_saved_successfully: '數據集保存成功',
    to_start_using: '瀏覽您的數據庫，表和列的內容。 選擇一個數據庫即可開始使用。',
    to_run_query: '點擊運行査詢',
    the_running_results: '即可查看運行結果',
    item: '項',
    logic_filter: '條件篩選',
    enum_filter: '枚舉篩選'
  },
  detabs: {
    custom_sort: '自定義排序',
    eidttitle: '編輯標題',
    selectview: '選擇視圖',
    selectOthers: '選擇組件',
    availableComponents: '可選組件',
    please: '未',
    head_position: '頭部位置'
  },
  example: {
    warning: '創建和編輯頁面是不能被 keep-alive 緩存的，因爲keep-alive 的 include 目前不支持根據路由來緩存，所以目前都是基於 component name 來進行緩存的。如果妳想類似的實現緩存效果，可以使用 localStorage 等瀏覽器緩存方案。或者不要使用 keep-alive 的 include，直接緩存所有頁面。詳情見'
  },
  errorLog: {
    tips: '請點擊右上角bug小圖標',
    description: '現在的管理後臺基本都是spa的形式了，它增強了用戶體驗，但同時也會增加頁面出問題的可能性，可能一個小小的疏忽就導致整個頁面的死鎖。好在 Vue 官網提供了一個方法來捕獲處理異常，妳可以在其中進行錯誤處理或者異常上報。',
    documentation: '文檔介紹'
  },
  excel: {
    export: '導出',
    selectedExport: '導出已選擇項',
    placeholder: '請輸入文件名(默認excel-list)'
  },
  zip: {
    export: '導出',
    placeholder: '請輸入文件名(默認file)'
  },
  pdf: {
    tips: '這裏使用   window.print() 來實現下載pdf的功能'
  },
  theme: {
    change: '換膚',
    documentation: '換膚文檔',
    tips: 'Tips: 它區別於 navbar 上的 theme-pick, 是兩種不同的換膚方法，各自有不同的應用場景，具體請參考文檔。',
    base: '基礎配色',
    font: '字體顏色',
    border: '邊框顏色',
    background: '背景顏色',
    custom: '自定義顏色',
    otherSave: '主題另存為',
    info: '主題信息',
    add: '新增主題',
    please_input_name: '請輸入名稱',
    name_repeat: '名稱已存在'
  },
  tagsView: {
    refresh: '刷新',
    close: '關閉',
    closeOthers: '關閉其它',
    closeAll: '關閉所有'
  },
  settings: {
    title: '繫統佈局配置',
    theme: '主題色',
    tagsView: '開啓 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '側邊欄 Logo'
  },
  sysParams: {
    display: '顯示設置',
    ldap: 'LDAP設置',
    oidc: 'OIDC設置',
    theme: '主題設置',
    cas: 'CAS設置',
    map: '地圖設置'
  },
  license: {
    i18n_no_license_record: '沒有 License 記錄',
    i18n_license_is_empty: 'License 爲空',
    title: '授權管理',
    corporation: '客戶名稱',
    time: '授權時間',
    product: '産品名稱',
    edition: '産品版本',
    licenseVersion: '授權版本',
    count: '授權數量',
    valid_license: '授權驗證',
    show_license: '查看授權',
    valid_license_error: '授權驗證失敗',
    status: '授權狀態',
    valid: '有效',
    invalid: '無效',
    expired: '已過期'
  },
  member: {
    create: '添加成員',
    modify: '修改成員',
    delete_confirm: '這個用戶確定要刪除嗎?',
    please_choose_member: '請選擇成員',
    search_by_name: '根據名稱搜索',
    modify_personal_info: '修改個人信息',
    edit_password: '重置密碼',
    edit_information: '編輯信息',
    input_name: '請輸入名稱',
    input_email: '請輸入郵箱',
    special_characters_are_not_supported: '不支持特殊字符',
    mobile_number_format_is_incorrect: '手機號碼格式不正確',
    email_format_is_incorrect: '郵箱格式不正確',
    password_format_is_incorrect: '有效密碼：8-30位，英文大小寫字母+數字+特殊字符（可選）',
    old_password: '舊密碼',
    new_password: '新密碼',
    repeat_password: '確認密碼',
    inconsistent_passwords: '兩次輸入的密碼不一致',
    remove_member: '確定要移除該成員嗎',
    org_remove_member: '將該用戶從組織中移除，將同時移除該組織下所有工作空間的權限，確定要移除該成員嗎？',
    input_id_or_email: '請輸入用戶 ID, 或者 用戶郵箱',
    no_such_user: '無此用戶信息, 請輸入正確的用戶 ID 或者 用戶郵箱！'
  },
  user: {
    create: '新建用戶',
    modify: '修改用戶',
    input_name: '請輸入用戶姓名',
    input_id: '請輸入ID',
    id_mandatory: 'ID為必填',
    name_mandatory: '姓名為必填',
    email_mandatory: '郵箱為必填',
    role_mandatory: '角色為必填',
    phone_format: '手機號碼格式錯誤',
    input_email: '請輸入郵箱',
    input_password: '請輸入密碼',
    input_phone: '請輸入電話號碼',
    input_roles: '請選擇角色',
    select_users: '請選擇用戶',
    select_gender: '請選擇性別',
    user_name_pattern_error: 'ID只能包含字母数字以及._-并以字母开头！',
    special_characters_are_not_supported: '不支持特殊字符',
    mobile_number_format_is_incorrect: '手機號碼格式不正確',
    email_format_is_incorrect: '郵箱格式不正確',
    delete_confirm: '這個用戶確定要刪除嗎?',
    apikey_delete_confirm: '這個 API Key 確定要刪除嗎?',
    input_id_placeholder: '請輸入ID (不支持中文)',
    source: '用戶來源',
    choose_org: '請選擇組織',
    reset_password: '重置密碼',
    current_user: '當前用戶',
    origin_passwd: '原始密碼',
    new_passwd: '新密碼',
    confirm_passwd: '確認密碼',
    change_password: '修改密碼',
    search_by_name: '按姓名搜索',
    import_ldap: '導入LDAP用戶',
    result_one: '個結果',
    clear_filter: '清空條件',
    recover_pwd: '是否恢復為初始密碼?',
    filter_method: '篩選條件',
    filter: '篩選',
    list: '列表項',
    list_info: '請選擇列表中要展示的信息',
    sure_delete: '確定刪除該用戶嗎？',
    wecom_id: '企業微信賬號',
    dingtalk_id: '釘釘賬號',
    lark_id: '飛書賬號',
    input_wecom_id: '請輸入企業微信賬號',
    input_dingtalk_id: '請輸入釘釘賬號',
    input_lark_id: '請輸入飛書賬號'
  },
  ldap: {
    url: 'LDAP地址',
    dn: '綁定DN',
    password: '密碼',
    ou: '用戶OU',
    filter: '用戶過濾器',
    mapping: 'LDAP屬性映射',
    open: '啓用LDAP認證',
    input_url: '請輸入LDAP地址',
    input_dn: '請輸入DN',
    input_password: '請輸入密碼',
    input_ou: '請輸入用戶OU',
    input_filter: '請輸入用戶過濾器',
    input_mapping: '請輸入LDAP屬性映射',
    input_username: '請輸入用戶名',
    input_url_placeholder: '請輸入LDAP地址 (如 ldap://localhost:389)',
    input_ou_placeholder: '輸入用戶OU (使用|分隔各OU)',
    input_filter_placeholder: '輸入過濾器 [可能的選項是cn或uid或sAMAccountName={0}, 如：(uid={0})]',
    input_mapping_placeholder: '如：{"userName":"uid","nickName":"cn","email":"mail"}, username映射的選項可能是cn或uid或sAMAccountName',
    test_connect: '測試連接',
    test_login: '測試登錄',
    edit: '編輯',
    login_success: '登錄成功',
    url_cannot_be_empty: 'LDAP 地址不能爲空',
    dn_cannot_be_empty: 'LDAP DN不能爲空',
    ou_cannot_be_empty: 'LDAP OU不能爲空',
    filter_cannot_be_empty: 'LDAP 用戶過濾器不能爲空',
    mapping_cannot_be_empty: 'LDAP 用戶屬性映射不能爲空',
    password_cannot_be_empty: 'LDAP 密碼不能爲空'
  },
  oidc: {
    auth_endpoint: '請輸入AuthEndpoint',
    token_endpoint: '請輸入TokenEndpoint',
    userinfo_endpoint: '請輸入UserinfoEndpoint',
    logout_endpoint: '請輸入logoutEndpoint',
    clientId: '請輸入ClientId',
    secret: '請輸入Secret',
    scope: '請輸入scope',
    redirectUrl: '請輸入redirectUrl',
    input_mapping: '請輸入OIDC屬性映射',
    open: '啓用OIDC認證'
  },
  role: {
    menu_authorization: '菜單授權',
    data_authorization: '數據授權',
    please_choose_role: '請選擇角色',
    admin: '繫統管理員',
    org_admin: '組織管理員',
    org_member: '組織成員',
    add: '新建角色',
    delete: '刪除角色',
    modify: '修改角色',
    tips: '提示',
    confirm_delete: '確認刪除角色 ',
    search_by_name: '按名稱搜索',
    role_name: '角色名稱',
    pls_input_name: '請輸入名稱',
    search_by_name_email: '通過姓名或郵箱搜索',
    api_role: 'API角色',
    role_exist: '添加失敗，該角色已存在',
    add_api_role: '添加API角色',
    can_not_move: '不可移除，至少保留一位管理員',
    manage_can_not_move: '管理員是系統預置角色，默認擁有系統管理全部權限，無法刪除',
    manage_can_not_update: '管理員是系統預置角色，默認擁有系統管理全部權限，無法編輯',
    role_description: '角色描述',
    editer_role: '編輯角色',
    add_role: '添加角色',
    role_name_exist: '該角色名稱已存在',
    search_by_role: '通過角色名稱搜索'
  },
  menu: {
    parent_category: '上級目錄',
    module_name: '組件名稱',
    module_path: '組件路徑',
    route_addr: '路由地址',
    menu_sort: '菜單排序',
    authority_identification: '權限標識',
    button_name: '按鈕名稱',
    select_icon: '選擇圖標',
    create_time: '創建日期',
    tile: '菜單標題',
    create: '創建菜單',
    modify: '修改菜單',
    delete: '刪除菜單',
    delete_confirm: '確定刪除菜單嗎',
    menu_type: '菜單類型'
  },
  organization: {
    parent_org: '上級組織',
    select_parent_org: '選擇上級組織',
    top_org: '頂級組織',
    name: '組織名稱',
    sort: '組織排序',
    sub_organizations: '下屬組織數',
    create_time: '創建日期',
    create: '新建組織',
    modify: '修改組織',
    delete_confirm: '確定要刪除該組織嗎?',
    input_name: '請輸入組織名稱',
    select_organization: '請選擇組織',
    search_by_name: '根據名稱搜索',
    special_characters_are_not_supported: '格式錯誤(不支持特殊字符，且不能以\'-\'開頭結尾)',
    select: '選擇組織',
    member: '成員',
    organization: '組織',
    add_user: '添加用戶',
    sure_move_user: '確定將該用戶從組織中移除嗎？',
    move_success: '移除成功',
    user: '用戶',
    add_organization: '添加組織',
    default_organization_cannot_move: '默認組織無法刪除',
    organization_name: '組織名稱',
    input_organization_name: '請輸入組織名稱',
    relate_top_organization: '關聯上級組織',
    organization_name_exist: '組織名稱已存在',
    cannot_delete: '無法刪除',
    remove_user_first: '請先移除組織中所有用戶以及子組織，再進行刪除組織操作。',
    sure_delete_organization: '確定刪除該組織嗎？',
    delete: '刪除',
    add_child_org: '添加子組織',
    edite_organization: '編輯組織'
  },
  system_parameter_setting: {
    email_server_config: '郵箱服務器配置',
    edit_success: '編輯成功',
    mailbox_service_settings: '郵件設置',
    test_connection: '測試連接',
    SMTP_host: 'SMTP主機',
    basic_setting: '基礎設置',
    front_time_out: '請求超時時間(單位:秒, 註意:保存後刷新瀏覽器生效)',
    msg_time_out: '消息保留時間(單位:天)',
    login_type: '默認登錄方式',
    empty_front: '為空則默認取值100秒',
    empty_msg: '為空則默認取值30天',
    front_error: '請填寫0-300正整數', // 修改了提示信息
    msg_error: '請填寫1-365正整數',
    limit_times_error: '請填寫1-100正整數',
    relieve_times_error: '請填寫1-100正整數',
    SMTP_port: 'SMTP端口',
    SMTP_account: 'SMTP賬戶',
    SMTP_password: 'SMTP密碼',
    SSL: '開啓SSL(如果SMTP端口是465，通常需要啓用SSL)',
    TLS: '開啓TLS(如果SMTP端口是587，通常需要啓用TLS)',
    SMTP: '是否免密 SMTP',
    host: '主機號不能爲空',
    port: '端口號不能爲空',
    account: '賬戶不能爲空',
    test_recipients: '測試收件人',
    tip: '提示：僅用來作爲測試郵件收件人',
    engine_mode_setting: '引擎設置',
    kettle_setting: 'Kettle 設置',
    cas_selected_warn: '選擇CAS方式保存後會註銷當前回話，重新登錄',
    cas_reset: 'CAS切換回默認登錄方式訪問API：',
    main_color: '主色',
    success_color: '成功顏色',
    warning_color: '警示顏色',
    wrong_color: '錯誤顏色',
    main_text_color: '主要文字顏色',
    secondary_font_color: '二級字體顏色',
    prompt_font_color: '提示字體顏色',
    disable_font_color: '禁用字體顏色',
    component_stroke_color: '組件描邊顏色',
    card_stroke_color: '卡片描邊顏色',
    basic_white: '基礎白色',
    page_background_color: '頁面背景色',
    disable_background_color: '輸入框禁用背景色',
    basic_black: '基礎黑色',
    label_color: '標籤顏色',
    system_theme: '系統主題',
    custom_theme: '自定義主題',
    color_settings: '配色設定',
    add_theme: '添加主題',
    subject_based: '基於主題',
    the_subject_name: '請輸入主題名稱',
    name_already_exists: '主題名稱已存在',
    successfully_and_apply: '保存成功並應用',
    sure_to_exit: '你填寫的資訊未保存，確認退出嗎？',
    copy_theme: '複製主題',
    advanced_configuration: '高級配寘',
    no_custom_theme: '暫無自定義主題',
    recommended_size: '建議尺寸',
    support: '支持',
    no_more_than: '大小不超過',
    request_timeout: '請求超時時間',
    message_retention_time: '消息保留時間',
    log_retention_time: '日誌保留時間',
    ds_check_time: '數據源檢測時間間隔',
    test_mail_recipient: '僅用來作為測試郵件收件人',
    to_enable_tsl: '如果SMTP埠是587，通常需要啟用TSL',
    to_enable_ssl: '如果SMTP埠是465，通常需要啟用SSL',
    added_successfully: '添加成功',
    text_link_etc: '適用場景：行動號召、選中態、資訊高亮、常規提示資訊、文字連結等',
    prompt_and_icon: '適用場景：成功狀態提示及圖標',
    prompt_and_icon_danger: '適用場景：警示狀態提示及圖標',
    icon_danger_button: '適用場景：錯誤狀態提示及圖標、危險按鈕',
    first_level_icon: '適用場景：一級標題、一級正文、重要資訊展示、一級圖標',
    copy_secondary_icon: '適用場景：二級標題、二級文案、二級圖標',
    radio_checkbox_unchecked: '適用場景：輸入框引導語、輔助文案、提示文案、三級圖標、radio、checkbox未選中態',
    button_background_color: '適用場景：禁用文案、禁用圖標、禁用按鈕背景色',
    scenario_component_stroking: '適用場景：組件描邊',
    background_header_background: '適用場景：頁面背景、表頭背景',
    main_background: '主背景',
    content_background: '內容背景',
    select_font: '選中字體',
    no_font_selected: '未選中字體',
    head_background: '頭部背景',
    head_font: '頭部字體',
    menu_floating_background: '選單懸浮背景',
    menu_selection_background: '選單選中背景',
    left_menu_background: '左側選單背景',
    left_menu_font: '左側選單字體',
    table_background: '表格背景',
    table_font: '表格字體',
    table_borders: '表格邊框',
    subject_name: '主題名稱',
    template_name: '模版名稱',
    search_keywords: '搜索關鍵字',
    delete_this_topic: '確定刪除該主題嗎？',
    network_error: '網絡錯誤',
    to_overwrite_them: '當前分類存在相同名稱模版，是否覆蓋？',
    import_succeeded: '導入成功',
    name_already_exists_type: '分類名稱已存在',
    rename_succeeded: '重命名成功',
    the_same_category: '同一分類下，該模版名稱已存在',
    delete_this_template: '確定刪除該模版嗎？',
    also_be_deleted: '刪除後，該分類中所有的模版也將被刪除。',
    delete_this_category: '確定刪除該分類嗎？',
    edit_template: '編輯模版',
    edit_classification: '編輯分類',
    classification_name: '分類名稱',
    by_event_details: '通過事件詳情搜索',
    password_input_error: '原始密碼輸入錯誤'
  },
  chart: {
    chart_refresh_tips: '視圖刷新設置優先於儀表板刷新設置',
    '1-trend': '趨勢',
    '2-state': '狀態',
    '3-rank': '排名',
    '4-location': '位置',
    '5-weather': '天氣',
    chinese: '中文',
    mark_field: '字段',
    mark_value: '值',
    function_style: '功能型樣式',
    condition_style: '標記樣式',
    longitude: '經度',
    latitude: '緯度',
    gradient: '漸變',
    layer_controller: '指標切換',
    suspension: '懸浮',
    chart_background: '組件背景',
    date_format: '選擇日期解析格式',
    solid_color: '純色',
    split_gradient: '分離漸變',
    continuous_gradient: '連續漸變',
    map_center_lost: '圖形缺失中心點centroid或center屬性，請補全後再試',
    margin_model: '模式',
    margin_model_auto: '自動',
    margin_model_absolute: '絕對',
    margin_model_relative: '相對',
    margin_placeholder: '請輸入0-100數字',
    margin_absolute_placeholder: '請輸入0-40數字',
    rich_text_view_result_tips: '富文本只選取第一條結果',
    rich_text_view: '富文本視圖',
    view_reset: '視圖重置',
    view_reset_tips: '放棄對視圖的修改？',
    export_img: '導出圖片',
    title_repeat: '當前標題已存在',
    save_snapshot: '保存縮略圖',
    datalist: '視圖',
    add_group: '添加分組',
    add_scene: '添加場景',
    group: '分組',
    scene: '場景',
    delete: '刪除',
    move_to: '移動到',
    rename: '重命名',
    tips: '提示',
    confirm_delete: '確認刪除',
    delete_success: '刪除成功',
    confirm: '確認',
    cancel: '取消',
    search: '搜索',
    back: '返回',
    add_table: '添加數據集',
    process: '進度',
    add_chart: '添加視圖',
    db_data: '數據庫數據集',
    sql_data: 'SQL數據集',
    excel_data: 'Excel數據集',
    custom_data: '自定義數據集',
    pls_slc_tbl_left: '請從左側選視圖',
    add_db_table: '添加數據庫數據集',
    add_api_table: '添加API數據集',
    pls_slc_data_source: '請選擇數據源',
    table: '表',
    edit: '編輯',
    create_view: '創建試圖',
    data_preview: '數據預覽',
    dimension: '維度',
    quota: '指標',
    title: '標題',
    show: '顯示',
    chart_type: '圖表類型',
    shape_attr: '圖形屬性',
    module_style: '組件樣式',
    result_filter: '過濾器',
    x_axis: '橫軸',
    y_axis: '縱軸',
    chart: '視圖',
    close: '關閉',
    summary: '彙總方式',
    fast_calc: '快速計算',
    sum: '求和',
    count: '計數',
    avg: '平均',
    max: '最大值',
    min: '最小值',
    stddev_pop: '標準差',
    var_pop: '方差',
    quick_calc: '快速計算',
    show_name_set: '顯示名設置',
    show_name: '顯示名',
    color: '顔色',
    color_case: '配色方案',
    pls_slc_color_case: '請選擇配色方案',
    color_default: '默認',
    color_retro: '複古',
    color_future: '未來',
    color_gradual: '漸變',
    color_business: '商務',
    color_gentle: '柔和',
    color_elegant: '淡雅',
    color_technology: '科技',
    color_simple: '簡潔',
    not_alpha: '不透明度',
    area_border_color: '地圖邊線',
    area_base_color: '底圖',
    size: '大小',
    bar_width: '柱寬',
    bar_gap: '柱間隔',
    adapt: '自適應',
    line_width: '線寬',
    line_type: '線型',
    line_symbol: '摺點',
    line_symbol_size: '摺點大小',
    line_type_solid: '實線',
    line_type_dashed: '虛線',
    line_symbol_circle: '圓形',
    line_symbol_emptyCircle: '空心圓',
    line_symbol_rect: '矩形',
    line_symbol_roundRect: '圓角矩形',
    line_symbol_triangle: '三角形',
    line_symbol_diamond: '菱形',
    line_symbol_pin: '釘子',
    line_symbol_arrow: '箭頭',
    line_symbol_none: '無',
    line_area: '面積',
    pie_inner_radius: '內徑',
    pie_outer_radius: '外徑',
    funnel_width: '寬度',
    line_smooth: '平滑摺線',
    title_style: '標題樣式',
    text_fontsize: '字體大小',
    text_color: '字體顔色',
    text_h_position: '水平位置',
    text_v_position: '垂直位置',
    text_pos_left: '左',
    text_pos_center: '中',
    text_pos_right: '右',
    text_pos_top: '上',
    text_pos_bottom: '下',
    text_italic: '字體傾斜',
    italic: '傾斜',
    orient: '方嚮',
    horizontal: '水平',
    vertical: '垂直',
    legend: '圖例',
    shape: '形狀',
    polygon: '多邊形',
    circle: '圓形',
    label: '標簽',
    label_position: '標簽位置',
    label_reserve_decimal_count: '保留小數',
    label_bg: '標簽背景',
    label_shadow: '標簽陰影',
    label_shadow_color: '陰影顏色',
    content_formatter: '內容格式',
    inside: '內',
    tooltip: '提示',
    tooltip_item: '數據項',
    tooltip_axis: '坐標軸',
    formatter_plc: '內容格式爲空時，顯示默認格式',
    xAxis: '橫軸',
    yAxis: '縱軸',
    position: '位置',
    rotate: '角度',
    name: '名稱',
    icon: '圖標',
    trigger_position: '觸發位置',
    asc: '升序',
    desc: '降序',
    sort: '排序',
    filter: '過濾',
    none: '無',
    background: '背景',
    border: '邊角',
    border_width: '邊框寬度',
    border_radius: '邊框半徑',
    alpha: '透明度',
    add_filter: '添加過濾',
    no_limit: '無限製',
    filter_eq: '等於',
    filter_not_eq: '不等於',
    filter_lt: '小於',
    filter_le: '小於等於',
    filter_gt: '大於',
    filter_ge: '大於等於',
    filter_null: '為空',
    filter_not_null: '不為空',
    filter_empty: '空字符串',
    filter_not_empty: '非空字符串',
    filter_include: '包含',
    filter_not_include: '不包含',
    rose_type: '玫瑰圖模式',
    radius_mode: '半徑',
    area_mode: '面積',
    rose_radius: '圓角',
    view_name: '視圖標題',
    belong_group: '所屬分組',
    select_group: '選擇分組',
    name_can_not_empty: '名稱不能爲空',
    template_can_not_empty: '請選擇儀表版',
    custom_count: '記錄數',
    table_title_fontsize: '表頭字體大小',
    table_item_fontsize: '表格字體大小',
    table_header_bg: '表頭背景',
    table_item_bg: '表格背景',
    table_header_font_color: '表頭字體',
    table_item_font_color: '表格字體',
    table_show_index: '顯示序號',
    stripe: '斑馬紋',
    start_angle: '起始角度',
    end_angle: '結束角度',
    style_priority: '樣式優先級',
    dashboard: '儀表闆',
    dimension_color: '名稱顔色',
    quota_color: '值顔色',
    dimension_font_size: '名稱字體大小',
    quota_font_size: '值字體大小',
    space_split: '名稱/值間隔',
    only_one_quota: '僅支持1個指標',
    only_one_result: '僅顯示第1個計算結果',
    dimension_show: '名稱顯示',
    quota_show: '值顯示',
    title_limit: '標題不能大於50個字符',
    filter_condition: '過濾條件',
    filter_field_can_null: '過濾字段必填',
    preview_100_data: '預覽前100條記錄',
    chart_table_normal: '彙總表',
    chart_table_info: '明細表',
    chart_card: '指標卡',
    chart_bar: '基礎柱狀圖',
    chart_bar_stack: '堆疊柱狀圖',
    chart_percentage_bar_stack: '百分比柱狀圖',
    chart_bar_horizontal: '橫嚮柱狀圖',
    chart_bar_stack_horizontal: '橫嚮堆疊柱狀圖',
    chart_percentage_bar_stack_horizontal: '橫嚮百分比柱狀圖',
    chart_line: '基礎摺線圖',
    chart_line_stack: '堆疊摺線圖',
    chart_pie: '餅圖',
    chart_pie_donut: '環形圖',
    chart_pie_rose: '南丁格爾玫瑰圖',
    chart_pie_donut_rose: '南丁格爾玫瑰環形圖',
    chart_funnel: '漏鬥圖',
    chart_radar: '雷達圖',
    chart_gauge: '儀表盤',
    chart_map: '地圖',
    dateStyle: '日期顯示',
    datePattern: '日期格式',
    y: '年',
    y_M: '年月',
    y_Q: '年季度',
    y_W: '年周',
    y_M_d: '年月日',
    H_m_s: '時分秒',
    y_M_d_H_m: '年月日時分',
    y_M_d_H_m_s: '年月日時分秒',
    date_sub: 'yyyy-MM-dd',
    date_split: 'yyyy/MM/dd',
    chartName: '新建視圖',
    chart_show_error: '無法正常顯示',
    chart_error_tips: '如有疑問請聯繫管理員',
    title_cannot_empty: '標題不能爲空',
    table_title_height: '表頭行高',
    table_item_height: '表格行高',
    axis_show: '軸線顯示',
    axis_color: '軸線顔色',
    axis_width: '軸線寬度',
    axis_type: '軸線類型',
    grid_show: '網格線顯示',
    grid_color: '網格線顏色',
    grid_width: '網格線寬度',
    grid_type: '網格線類型',
    axis_type_solid: '實線',
    axis_type_dashed: '虛線',
    axis_type_dotted: '點',
    axis_label_show: '標簽顯示',
    axis_label_color: '標簽顔色',
    axis_label_fontsize: '標簽大小',
    text_style: '字體樣式',
    bolder: '加粗',
    change_ds: '更換數據集',
    change_ds_tip: '提示：更換數據集將導致字段發生變化，需重新製作視圖',
    axis_name_color: '名稱顔色',
    axis_name_fontsize: '名稱字體',
    pie_label_line_show: '引導線',
    outside: '外',
    center: '中心',
    split: '軸線',
    axis_line: '軸線',
    axis_label: '軸標簽',
    label_fontsize: '標簽大小',
    split_line: '分割線',
    split_color: '分割顔色',
    shadow: '陰影',
    condition: '過濾值',
    filter_value_can_null: '過濾值不能爲空',
    filter_like: '包含',
    filter_not_like: '不包含',
    filter_in: '屬於',
    filter_not_in: '不屬於',
    color_light: '明亮',
    color_classical: '經典',
    color_fresh: '清新',
    color_energy: '活力',
    color_red: '火紅',
    color_fast: '輕快',
    color_spiritual: '靈動',
    chart_details: '視圖明細',
    export: '導出',
    details: '明細',
    image: '圖片',
    export_details: '導出明細',
    chart_data: '數據',
    chart_style: '樣式',
    drag_block_type_axis: '類別軸',
    drag_block_value_axis: '值軸',
    drag_block_table_data_column: '數據列',
    drag_block_pie_angel: '扇區角度',
    drag_block_pie_label: '扇區標簽',
    drag_block_gauge_angel: '指針角度',
    drag_block_label_value: '值',
    drag_block_funnel_width: '漏鬥層寬',
    drag_block_funnel_split: '漏鬥分層',
    drag_block_radar_length: '分支長度',
    drag_block_radar_label: '分支標簽',
    map_range: '地圖範圍',
    select_map_range: '請選擇地圖範圍',
    area: '地區',
    stack_item: '堆疊項',
    placeholder_field: '拖動字段至此處',
    axis_label_rotate: '標簽角度',
    chart_scatter_bubble: '氣泡圖',
    chart_scatter: '散點圖',
    bubble_size: '氣泡大小',
    chart_treemap: '矩形樹圖',
    drill: '鑽取',
    drag_block_treemap_label: '色塊標簽',
    drag_block_treemap_size: '色塊大小',
    bubble_symbol: '圖形',
    gap_width: '間隔',
    width: '寬度',
    height: '高度',
    system_case: '繫統方案',
    custom_case: '自定義',
    last_layer: '當前已經是最後一級',
    radar_size: '大小',
    chart_mix: '組合圖',
    axis_value: '軸值',
    axis_value_min: '最小值',
    axis_value_max: '最大值',
    axis_value_split: '間隔',
    axis_auto: '自動',
    table_info_switch: '明細表切換將清空維度',
    drag_block_value_axis_main: '主軸值',
    drag_block_value_axis_ext: '副軸值',
    yAxis_main: '主縱軸',
    yAxis_ext: '副縱軸',
    total: '共',
    items: '條數據',
    chart_liquid: '水波圖',
    drag_block_progress: '進度指示',
    liquid_max: '目標值',
    liquid_outline_border: '邊框粗細',
    liquid_outline_distance: '邊框間隔',
    liquid_wave_length: '水波長度',
    liquid_wave_count: '水波數量',
    liquid_shape: '形狀',
    liquid_shape_circle: '圓形',
    liquid_shape_diamond: '菱形',
    liquid_shape_triangle: '三角形',
    liquid_shape_pin: '氣球',
    liquid_shape_rect: '矩形',
    dimension_or_quota: '維度或指標',
    axis_value_split_count: '刻度數',
    axis_value_split_space: '刻度間距',
    chart_waterfall: '瀑佈圖',
    pie_inner_radius_percent: '內徑佔比',
    pie_outer_radius_size: '外徑大小',
    table_page_size: '分頁',
    table_page_size_unit: '條/頁',
    result_count: '結果展示',
    result_mode_all: '全部',
    result_mode_custom: '自定義',
    chart_word_cloud: '詞雲',
    drag_block_word_cloud_label: '詞標簽',
    drag_block_word_cloud_size: '詞大小',
    splitCount_less_100: '刻度數範圍0-100',
    change_chart_type: '更改類型',
    chart_type_table: '表格',
    chart_type_quota: '指標',
    chart_type_trend: '趨勢',
    chart_type_compare: '比較',
    chart_type_distribute: '分佈',
    chart_type_relation: '關繫',
    chart_type_space: '空間位置',
    preview: '上一步',
    next: '下一步',
    select_dataset: '選擇數據集',
    select_chart_type: '選擇圖表類型',
    recover: '重置',
    yoy_label: '同比/環比',
    yoy_setting: '同環比設置',
    pls_select_field: '請選擇字段',
    compare_date: '對比日期',
    compare_type: '對比類型',
    compare_data: '數據設置',
    year_yoy: '年同比',
    month_yoy: '月同比',
    quarter_yoy: '季同比',
    week_yoy: '周同比',
    day_yoy: '日同比',
    year_mom: '年環比',
    month_mom: '月環比',
    quarter_mom: '季環比',
    week_mom: '周環比',
    day_mom: '日環比',
    data_sub: '對比差值',
    data_percent: '差值百分比',
    compare_calc_expression: '計算公式',
    and: '與',
    or: '或',
    logic_exp: '邏輯條件',
    enum_exp: '字段枚舉值',
    pls_slc: '請選擇',
    filter_exp: '過濾值',
    filter_type: '過濾方式',
    filter_value_can_not_str: '數值類型字段過濾值不能包含文本',
    enum_value_can_not_null: '字段枚舉值不能為空',
    table_config: '表格配置',
    table_column_width_config: '列寬調整',
    table_column_adapt: '自適應',
    table_column_custom: '自定義',
    chart_table_pivot: '透視表',
    table_pivot_row: '數據行',
    field_error_tips: '該字段所對應的數據集原始字段發生變更（包括維度、指標，字段類型，字段被刪除等），建議重新編輯',
    mark_field_error: '數據集變更，當前字段不存在，請重新選擇',
    table_border_color: '邊框顏色',
    table_header_align: '表頭對齊方式',
    table_item_align: '表格對齊方式',
    table_align_left: '左對齊',
    table_align_center: '居中',
    table_align_right: '右對齊',
    table_scroll_bar_color: '滾動條顏色',
    draw_back: '收回',
    senior: '高級',
    senior_cfg: '高級設置',
    function_cfg: '功能設置',
    analyse_cfg: '分析預警',
    slider: '縮略軸',
    slider_range: '默認範圍',
    slider_bg: '背景',
    slider_fill_bg: '選中背景',
    slider_text_color: '字體顏色',
    chart_no_senior: '當前圖表類型暫無高級配置，敬請期待',
    chart_no_properties: '當前圖表類型暫無樣式配置.',
    assist_line: '輔助線',
    field_fixed: '固定值',
    line_type_dotted: '點',
    value_can_not_empty: '值不能為空',
    value_error: '值必須為數值',
    threshold: '閾值',
    threshold_range: '閾值區間',
    gauge_threshold_format_error: '格式錯誤',
    total_cfg: '總計配置',
    col_cfg: '列匯總',
    row_cfg: '行匯總',
    total_show: '總計',
    total_position: '位置',
    total_label: '別名',
    sub_total_show: '小計',
    total_pos_top: '頂部',
    total_pos_bottom: '底部',
    total_pos_left: '左側',
    total_pos_right: '右側',
    chart_label: '文本卡',
    drag_block_label: '標簽',
    count_distinct: '去重計數',
    table_page_mode: '分頁模式',
    page_mode_page: '翻頁',
    page_mode_pull: '下拉',
    exp_can_not_empty: '條件不能為空',
    value_formatter: '數值格式',
    value_formatter_type: '格式類型',
    value_formatter_auto: '自動',
    value_formatter_value: '數值',
    value_formatter_percent: '百分比',
    value_formatter_unit: '數量單位',
    value_formatter_decimal_count: '小數位數',
    value_formatter_suffix: '單位後綴',
    value_formatter_thousand_separator: '千分符',
    value_formatter_example: '示例',
    unit_none: '無',
    unit_thousand: '千',
    unit_ten_thousand: '萬',
    unit_million: '百萬',
    unit_hundred_million: '億',
    formatter_decimal_count_error: '請輸入0-10的整數',
    gauge_threshold_compare_error: '閾值範圍需逐級遞增',
    tick_count: '刻度間隔數',
    custom_sort: '自定義',
    custom_sort_tip: '自定義排序優先級最高，且僅支持單個字段自定義',
    clean_custom_sort: '清除自定義排序',
    ds_field_edit: '數據集字段管理',
    chart_field_edit: '視圖字段管理',
    copy_field: '復製字段',
    calc_field: '計算字段',
    form_type: '類別',
    scroll_cfg: '滾動設置',
    scroll: '滾動',
    open: '開啟',
    row: '行數',
    interval: '間隔',
    max_more_than_mix: '最大值必須大於最小值',
    field: '字段',
    textColor: '文字顏色',
    backgroundColor: '背景顏色',
    field_can_not_empty: '字段不能為空',
    conditions_can_not_empty: '字段的條件不能為空，若無條件，請直接刪除該字段',
    remark: '備註',
    remark_edit: '編輯備註',
    remark_bg_color: '背景填充',
    quota_font_family: '值字體',
    quota_text_style: '值樣式',
    quota_letter_space: '值字間距',
    dimension_font_family: '名稱字體',
    dimension_text_style: '名稱樣式',
    dimension_letter_space: '名稱字間距',
    font_family: '字體',
    letter_space: '字間距',
    font_shadow: '字體陰影',
    chart_area: '面積圖',
    fix: '固定值',
    dynamic: '動態值',
    gauge_size_field_delete: '動態值中字段發生變更，請重新編輯',
    chart_group: '子類別',
    chart_bar_group: '分組柱狀圖',
    chart_bar_group_stack: '分組堆疊柱狀圖',
    field_dynamic: '動態值',
    aggregation: '聚合方式',
    filter_between: '介於',
    field_not_empty: '字段不能為空',
    summary_not_empty: '聚合方式不能為空',
    reserve_zero: '取整',
    reserve_one: '一位',
    reserve_two: '兩位',
    proportion: '佔比',
    label_content: '標籤展示',
    percent: '占比',
    table_index_desc: '表頭名稱',
    total_sort: '總計排序',
    total_sort_none: '無',
    total_sort_asc: '升序',
    total_sort_desc: '降序',
    total_sort_field: '排序字段',
    empty_data_strategy: '空值處理',
    break_line: '保持為空',
    set_zero: '置為0',
    ignore_data: '隱藏空值',
    sub_dimension_tip: '該字段為必填項，且不應使用類別軸中的字段，若無需該字段，請選擇基礎圖表進行展示，否則展示效果不理想',
    drill_dimension_tip: '鑽取字段僅支持數據集中的字段',
    table_scroll_tip: '明細表僅在分頁模式為"下拉"時生效。',
    table_threshold_tip: '提示：請勿重複選擇字段，若同一字段重複配置，則只有最後的字段配置生效。',
    table_column_width_tip: '列寬並非任何時候都能生效。<br/>容器寬度優先級高於列寬。即(表格容器寬度 / 列數 > 指定列寬)，則列寬優先取(容器寬度 / 列數)',
    reference_field_tip: '引用字段以 "[" 開始，"]" 結束。請<br/>勿修改引用內容，否則將引用失敗。<br/>若輸入與引用字段相同格式的內容，將被當做引用字段處理。',
    scatter_tip: '該指標生效時，樣式大小中的氣泡大小屬性將失效',
    place_name_mapping: '地名映射',
    axis_tip: '最小值、最大值、間隔均為數值類型；若不填，則該項視為自動。<br/>請確保填寫數值能正確計算，否則將無法正常顯示值軸',
    format_tip: `模板變量有 {a}, {b}，{c}，{d}，分別表示系列名，數據名，數據值等。<br>
                  在 觸發位置 為 '坐標軸' 的時候，會有多個系列的數據，此時可以通過 {a0}, {a1}, {a2} 這種後面加索引的方式表示系列的索引。<br>
                  不同圖表類型下的 {a}，{b}，{c}，{d} 含義不一樣。 其中變量{a}, {b}, {c}, {d}在不同圖表類型下代表數據含義為：<br><br>
                  折線（區域）圖、柱狀（條形）圖、儀表盤 : {a}（系列名稱），{b}（類目值），{c}（數值）<br>
                  餅圖、漏鬥圖: {a}（系列名稱），{b}（數據項名稱），{c}（數值）, {d}（百分比）<br>
                  地圖 : {a}（系列名稱），{b}（區域名稱），{c}（合並數值）, {d}（無）<br>
                  散點圖（氣泡）圖 : {a}（系列名稱），{b}（數據名稱），{c}（數值數組）, {d}（無）`,
    h_position: '水平位置',
    v_position: '垂直位置',
    p_left: '左對齊',
    p_right: '右對齊',
    p_top: '上對齊',
    p_bottom: '下對齊',
    p_center: '居中'
  },
  dataset: {
    spend_time: '耗時',
    sql: 'SQL 語句',
    sql_result: '運行結果',
    parse_filed: '解析字段',
    field_rename: '字段重命名',
    params_work: '僅在編輯 sql 時生效',
    sql_variable_limit_1: '1、SQL變數只能在WHERE條件中使用',
    sql_variable_limit_2: '2、示例：select * from table_name where column_name1=\'${param_name1}\' and column_name2 in \'${param_name2}\'',
    selesql_variable_limit_2ct_year: '選擇年',
    select_month: '選擇月',
    select_date: '選擇日期',
    select_time: '選擇時間',
    time_year: '日期-年',
    time_year_month: '日期-年月',
    time_year_month_day: '日期-年月日',
    time_all: '日期-年月日時分秒',
    dataset_sync: ' ( 資料同步中... )',
    sheet_warn: '有多個 Sheet 頁，默認抽取第一個',
    datalist: '數據集',
    name: '數據集名稱',
    add_group: '添加分組',
    add_scene: '添加場景',
    group: '分組',
    scene: '場景',
    delete: '刪除',
    move_to: '移動到',
    rename: '重命名',
    tips: '提示',
    confirm_delete: '確認刪除',
    confirm_delete_msg: '刪除數據機，會影響與其相關的自定義數據機、 關聯數據機、儀表板，確認刪除',
    delete_success: '刪除成功',
    confirm: '確認',
    cancel: '取消',
    search: '搜索',
    back: '返回',
    add_table: '添加數據集',
    process: '進度',
    update: '更新',
    db_data: '數據庫數據集',
    sql_data: 'SQL 數據集',
    excel_data: 'Excel 數據集',
    custom_data: '自定義數據集',
    pls_slc_tbl_left: '請從左側選擇表',
    add_db_table: '添加數據庫數據集',
    add_api_table: '添加API數據集',
    pls_slc_data_source: '請選擇數據源',
    table: '表',
    edit: '編輯',
    create_view: '創建視圖',
    data_preview: '數據預覽',
    field_type: '字段類型',
    field_name: '字段名稱',
    field_origin_name: '原始名稱',
    field_check: '選中',
    update_info: '更新信息',
    update_records: '更新記錄',
    join_view: '數據關聯',
    text: '文本',
    time: '時間',
    value: '數值',
    mode: '模式',
    direct_connect: '直連',
    sync_data: '定時同步',
    update_setting: '更新設置',
    sync_now: '立即更新',
    add_task: '添加任務',
    task_name: '任務名稱',
    task_id: '任務ID',
    start_time: '開始時間',
    end_time: '結束時間',
    status: '狀態',
    error: '失敗',
    completed: '成功',
    underway: '執行中',
    task_update: '更新設置',
    update_type: '更新方式',
    all_scope: '全量更新',
    add_scope: '增量更新',
    select_data_time: '選擇日期時間',
    execute_rate: '執行頻率',
    execute_once: '立即執行',
    simple_cron: '簡單重複',
    cron_config: '表達式設定',
    no_limit: '無限製',
    set_end_time: '設定結束時間',
    operate: '操作',
    save_success: '保存成功',
    close: '關閉',
    required: '必填',
    input_content: '請輸入內容',
    add_sql_table: '添加 SQL 數據集',
    preview: '預覽',
    pls_input_name: '請輸入名稱',
    connect_mode: '連接模式',
    incremental_update_type: '增量更新方式',
    incremental_add: '增量添加',
    incremental_delete: '增量刪除',
    last_update_time: '上次更新時間',
    current_update_time: '當前更新時間',
    param: '參數',
    edit_sql: '編輯 SQL 數據集',
    showRow: '顯示行',
    add_excel_table: '添加Excel數據集',
    add_custom_table: '添加自定義數據集',
    upload_file: '上傳文件',
    detail: '詳情',
    type: '類型',
    create_by: '創建者',
    create_time: '創建時間',
    preview_show: '顯示',
    preview_item: '條數據',
    preview_total: '共',
    pls_input_less_5: '請輸入5位以內的正整數',
    field_edit: '編輯字段',
    table_already_add_to: '該表已添加至',
    uploading: '上傳中...',
    add_union: '新建關聯',
    union_setting: '關聯設置',
    pls_slc_union_field: '請選擇關聯字段',
    pls_slc_union_table: '請選擇關聯表',
    source_table: '關聯表',
    source_field: '關聯字段',
    target_table: '被關聯表',
    target_field: '被關聯字段',
    union_relation: '關聯關繫',
    pls_setting_union_success: '請正確設置關聯關繫',
    invalid_dataset: 'Kettle未運行，無效數據集',
    check_all: '全選',
    can_not_union_self: '被關聯表不能與關聯表相同',
    float: '小數',
    edit_custom_table: '編輯自定義數據集',
    edit_field: '編輯字段',
    preview_100_data: '顯示前100行數據',
    invalid_table_check: '非直連數據集請先完成數據同步',
    parse_error: 'Excel解析失敗，請檢查格式、字段等信息。具體參考：https://dataease.io/docs/user_manual/dataset_configuration/dataset_Excel',
    origin_field_type: '字段原始類型',
    edit_excel_table: '編輯Excel數據集',
    edit_excel: '編輯Excel',
    excel_replace: '替換',
    excel_add: '追加',
    dataset_group: '數據集分組',
    m1: '將 ',
    m2: ' 移動到',
    char_can_not_more_50: '數據集名稱不能超過50個字符',
    task_add_title: '添加任務',
    task_edit_title: '編輯任務',
    sync_latter: '稍後同步',
    task: {
      list: '任務列表',
      record: '執行記錄',
      create: '新建任務',
      name: '任務名稱',
      last_exec_time: '上次執行時間',
      next_exec_time: '下次執行時間',
      last_exec_status: '上次執行結果',
      task_status: '任務狀態',
      dataset: '數據集',
      search_by_name: '根據名稱搜索',
      underway: '等待執行',
      stopped: '執行結束',
      exec: '執行中',
      pending: '暫停',
      confirm_exec: '手動觸發執行？',
      change_success: '狀態切換成功',
      excel_replace_msg: '可能會影響計算欄位、自定義數據集、關聯數據集、儀表板等，確認替換？',
      effect_ext_field: '會影響計算欄位'
    },
    field_group_type: '分類',
    location: '地理位置',
    left_join: '左連接',
    right_join: '右連接',
    inner_join: '內連接',
    full_join: '全連接',
    can_not_union_diff_datasource: '被關聯數據集必須與當前數據集的數據源一致',
    operator: '操作',
    d_q_trans: '維度/指標轉換',
    add_calc_field: '新建計算字段',
    input_name: '請輸入名稱',
    field_exp: '字段表達式',
    data_type: '數據類型',
    click_ref_field: '點擊引用字段',
    click_ref_function: '點擊引用函數',
    field_manage: '字段关联',
    edit_calc_field: '編輯計算字段',
    calc_field: '計算字段',
    show_sql: '顯示SQL',
    ple_select_excel: '請選擇要導入的 Excel',
    merge: '合並',
    no_merge: '不合並',
    merge_msg: '數據表中存在字段一致的情況，是否合並到一個數據集中?',
    merge_title: '合並數據',
    field_name_less_50: '字段名不能超過50個字符',
    excel_info_1: '1、Excel 文件中不能存在合併單元格；',
    excel_info_2: '2、Excel 文件的第一行為標題行，不能為空，不能為日期；',
    excel_info_3: '3、文件不超過500M。',
    sync_field: '同步字段',
    confirm_sync_field: '確認同步',
    confirm_sync_field_tips: '同步字段可能會導致已編輯字段發生變更，請確認',
    sync_success: '同步成功',
    sync_success_1: '同步成功，請對當前數據集重新執行數據同步操作',
    row_permission: {
      type: '類型',
      name: '名稱',
      condition: '條件',
      value: '值',
      add: '添加行權限',
      edit: '編輯行權限',
      please_select_field: '請選擇字段',
      please_select_auth_type: '請選擇授權類型',
      please_select_auth_id: '請選擇授權目標',
      row_permission_not_empty: '行權限不能為空',
      search_by_filed_name: '根據字段名稱搜索',
      auth_type: '授權類型',
      auth_obj: '授權對象'
    },
    column_permission: {
      add: '添加列權限',
      edit: '編輯列權限',
      please_select_field: '請選擇字段',
      please_select_auth_type: '請選擇授權類型',
      please_select_auth_id: '請選擇授權目標',
      column_permission_not_empty: '列權限不能為空',
      auth_type: '授權類型',
      auth_obj: '授權對象',
      enable: '啟用',
      disable: '禁用',
      prohibit: '禁用',
      desensitization: '脫敏',
      desensitization_rule: '脱敏規則',
      m: 'M等於',
      n: 'N等於',
      mgtn: 'M 不能大於 N'
    },
    row_permissions: '行權限',
    column_permissions: '列權限',
    row_column_permissions: '行列權限',
    union_data: '關聯數據集',
    add_union_table: '添加關聯數據集',
    edit_union: '編輯關聯數據集',
    union: '關聯',
    edit_union_relation: '編輯關聯關繫',
    add_union_relation: '新建關聯關繫',
    field_select: '字段選擇',
    add_union_field: '添加關聯字段',
    union_error: '關聯關繫與關聯字段不能為空',
    union_repeat: '當前數據集已被關聯，請勿重復關聯',
    preview_result: '預覽結果',
    sql_ds_union_error: '直連模式下SQL數據集，不支持關聯',
    api_data: 'API 數據集',
    copy: '復製',
    sync_log: '同步日誌',
    field_edit_name: '字段名稱',
    input_edit_name: '請輸入字段名稱',
    edit_search: '通過名稱搜索',
    na: '暫無',
    date_format: '時間格式，默認：年-月-日 時:分:秒',
    export_dataset: '數據集導出',
    filename: '文件名稱',
    export_filter: '篩選條件',
    pls_input_filename: '請輸入文件名稱',
    calc_tips: {
      tip1: '表達式語法請遵循該數據源對應的數據庫語法。',
      tip2: '數據集中不支持聚合運算。',
      tip3: '引用字段以 "[" 開始， "]" 結束',
      tip4: '請勿修改引用內容，否則將引用失敗',
      tip5: '若輸入與引用字段相同格式的內容，將被當作引用字段處理',
      tip6: '使用數據集對應數據庫類型所支持的函數，語法同對應數據庫',
      tip7: '如日期格式化：MySQL使用DATE_FORMAT(date,format)；Oracle使用TO_DATE(X,[,fmt])',
      tip8: '非直連模式數據集，使用Doris數據庫函數，可參考Doris官網'
    }
  },
  driver: {
    driver: '驅動',
    please_choose_driver: '青選擇驅動',
    mgm: '驅動管理',
    exit_mgm: '退出驅動管理',
    add: '添加驅動',
    modify: '修改',
    show_info: '驅動信息',
    file_name: '文件名',
    version: '版本',
    please_set_driverClass: '請指定驅動類'
  },
  datasource: {
    data_source_configuration: '數據源配寘',
    data_source_table: '數據源錶',
    auth_method: '認證方式',
    passwd: '用戶名密碼',
    kerbers_info: '請確保 krb5.Conf、Keytab Key，已經添加到路徑：/opt/dataease/conf',
    client_principal: 'Client Principal',
    keytab_Key_path: 'Keytab Key Path',
    datasource: '數據源',
    please_select_left: '請從左側選擇',
    show_info: '數據源信息',
    create: '新建數據源',
    type: '類型',
    please_choose_type: '請選擇數據源類型',
    please_choose_data_type: '請選擇計算模式',
    data_base: '數據庫名稱',
    user_name: '用戶名',
    password: '密碼',
    host: '主機名/IP地址',
    doris_host: 'Doris 地址',
    query_port: 'Query Port',
    http_port: 'Http Port',
    port: '端口',
    datasource_url: '地址',
    please_input_datasource_url: '請輸入 Elasticsearch 地址，如: http://es_host:es_port',
    please_input_data_base: '請輸入數據庫名稱',
    please_select_oracle_type: '選擇連接類型',
    please_input_user_name: '請輸入用戶名',
    please_input_password: '請輸入密碼',
    please_input_host: '請輸入主機',
    please_input_url: '請輸入URL地址',
    please_input_port: '請輸入端口',
    modify: '編輯數據源',
    copy: '複製數據源',
    validate_success: '校驗成功',
    validate: '校驗',
    search_by_name: '根據名稱搜索',
    delete_warning: '確定要刪除嗎?',
    input_name: '請輸入名稱',
    input_limit_2_25: '2-25字符',
    input_limit_2_50: '2-50字符',
    input_limit: '{num}字符',
    oracle_connection_type: '服務名/SID',
    oracle_sid: 'SID',
    oracle_service_name: '服務名',
    get_schema: '獲取 Schema',
    schema: '數據庫 Schema',
    charset: '字符集',
    targetCharset: '目標字符集',
    please_choose_schema: '請選擇數據庫 Schema',
    please_choose_targetCharset: '請選擇目標字符集',
    please_choose_charset: '請選擇數據庫字符集',
    edit_datasource_msg: '修改數據源信息，可能會導致改數據源下的數據集不可用，確認修改？',
    repeat_datasource_msg: '已經存在相同配置的數據源信息，',
    confirm_save: '確認保存?',
    in_valid: '無效數據源',
    initial_pool_size: '初始連接數',
    min_pool_size: '最小連接數',
    max_pool_size: '最大連接數',
    max_idle_time: '最大空閑(秒)',
    bucket_num: 'Bucket 數量',
    replication_num: '副本數量',
    please_input_bucket_num: '請輸入 Bucket 數量',
    please_input_replication_num: '請輸入副本數量',
    acquire_increment: '增長數',
    connect_timeout: '連接超時(秒)',
    please_input_initial_pool_size: '請輸入初始連接數',
    please_input_min_pool_size: '請輸入最小連接數',
    please_input_max_pool_size: '請輸入最大連接數',
    please_input_max_idle_time: '請輸入最大空閑(秒)',
    please_input_acquire_increment: '請輸入增長數',
    please_input_query_timeout: '請輸入查詢超時',
    please_input_connect_timeout: '請輸輸入連接超時(秒)',
    no_less_then_0: '高級設置中的參數不能小於零',
    port_no_less_then_0: '端口不能小於零',
    priority: '高級設置',
    data_mode: '數據模式',
    direct: '直連模式',
    extract: '抽取模式',
    all_compute_mode: '直連、抽取模式',
    extra_params: '額外的JDBC連接字符串',
    please_input_dataPath: '請輸入 JsonPath 數據路徑',
    show_api_data: '查看API数据結構',
    warning: '包含無效數據表',
    data_table: '數據表',
    data_table_name: '數據表名稱',
    method: '請求方式',
    url: 'URL',
    add_api_table: '添加 API 數據表',
    edit_api_table: '編輯 API 數據表',
    base_info: '基礎信息',
    column_info: '資料結構',
    request: '請求',
    isUseJsonPath: '是否指定JsonPath',
    path_all_info: '請輸入完整地址',
    jsonpath_info: '請輸入JsonPath',
    req_param: '請求參數',
    headers: '請求頭',
    key: '鍵',
    value: '值',
    data_path: '提取數據',
    data_path_desc: '請用 JsonPath 填寫數據路徑',
    body_form_data: 'form-data',
    body_x_www_from_urlencoded: 'x-www-form-urlencoded',
    body_json: 'json',
    body_xml: 'xml',
    body_raw: 'row',
    request_body: '請求提',
    auth_config: '認證配置',
    auth_config_info: '請求需要進行權限校驗',
    verified: '認證',
    verification_method: '認證方式',
    username: '用戶名',
    api_table_not_empty: 'API 數據表不能為空',
    has_repeat_name: 'API 數據表名稱重複',
    has_repeat_field_name: '欄位名重複，請修改後再選擇',
    api_field_not_empty: '欄位不能為空',
    success_copy: '複製成功',
    valid: '有效',
    invalid: '無效',
    api_step_1: '連接API',
    api_step_2: '選取數據',
    _ip_address: '請輸入主機名/ IP地址',
    display_name: '顯示名稱',
    connection_mode: '連接管道',
    driver_file: '驅動檔案',
    edit_driver: '編輯驅動',
    driver_name: '驅動名稱',
    drive_type: '驅動類型',
    add_driver: '添加驅動',
    diver_on_the_left: '請在左側選擇驅動',
    no_data_table: '暫無資料表',
    on_the_left: '請在左側選擇數據源',
    table_name: '表名稱',
    create_dataset: '創建數據集',
    field_description: '欄位描述',
    table_description: '表描述',
    relational_database: '關係型數據庫',
    data_warehouse_lake: '數倉/數據湖',
    non_relational_database: '非關係型數據庫',
    all: '所有',
    other: '其他',
    this_data_source: '確定刪除該數據源嗎？',
    delete_this_dataset: '確定删除該數据集嗎？',
    cannot_be_deleted_dataset: '該數据集存在如下血緣關係，删除會造成相關儀錶板的視圖失效，確定删除？',
    cannot_be_deleted_datasource: '該數據源存在如下血緣關係，删除會造成相關儀錶板的視圖失效，確定删除？',
    edit_folder: '編輯資料夾',
    click_to_check: '點擊去查看血緣關係',
    delete_this_item: '是否要刪除此項？',
    can_be_uploaded: '僅支持上傳JAR格式的檔案',
    query_timeout: '査詢超時',
    add_data_source: '添加數據源',
    delete_this_driver: '確定刪除該驅動嗎？',
    basic_info: '基本信息'
  },
  pblink: {
    key_pwd: '請輸入密碼打開鏈接',
    input_placeholder: '請輸入4位數字或字母',
    pwd_error: '密碼錯誤',
    pwd_format_error: '請輸入4位數字或字母',
    sure_bt: '確定',
    back_parent: '返回上一級'
  },
  panel: {
    forbidden_copy: '當前組件不允許復製',
    url_check_error: '跳轉錯誤，URL不合法',
    view_style: '視圖樣式',
    view_color_setting: '視圖配色',
    border_color_setting: '邊框配色',
    unpublished_tips: '取消發布後，該儀表板不能被查看。確定要取消發布？',
    position_adjust_component: '位置調整',
    active_font_size: '选中字體大小',
    carousel: '輪播',
    switch_time: '切換時間',
    position_adjust: '位置',
    space_top: '上',
    space_left: '左',
    space_width: '寬',
    space_height: '高',
    to_top: '置頂',
    down: '下載',
    mobile_style_setting: '樣式設置',
    mobile_style_setting_tips: '自定義移動端背景',
    board: '邊框',
    text: '文字',
    board_background: '背景',
    title_color: '標題顏色',
    input_style: '輸入框樣式(顏色)',
    overall_setting: '整體配置',
    panel_background: '儀表板背景',
    component_color: '組件配色',
    chart_title: '圖表標題',
    filter_component: '過濾組件',
    enable_refresh_view: '開啟刷新',
    enable_view_loading: '視圖加載提示',
    image_size_tips: '圖片請不要大於15M',
    image_add_tips: '只能插入圖片',
    watermark: '水印',
    panel_get_data_error: '獲取儀表板信息失敗，儀表板可能已經被刪除，請檢查儀表板狀態',
    panel_no_save_tips: '存在未保存的儀表板',
    panel_cache_use_tips: '檢查到上次有儀表板未能正常保存，是否使用上次未保存的儀表板？',
    template_name_tips: '儀表板名稱必填',
    panel_background_item: '自定義儀表板背景',
    panel_background_image_tips: '當前支持.jpeg,.jpg,.png,.gif文件,大小不要超過15M',
    reUpload: '重新上傳',
    create_by: '創建人',
    create_time: '創建時間',
    update_by: '最近修改人',
    update_time: '最近修改時間',
    target_url: '目標URL',
    target_url_tips: '可以點擊字段用來拼接URL或者參數',
    select_world: '點擊選擇字段',
    template_market: '模板市場',
    template_preview: '預覽模板',
    apply: '應用',
    apply_this_template: '應用此模板',
    market_network_tips: '查看模板市場模板需要服務器與模板市場(https://dataease.io/templates)連通，請檢查網絡...',
    enter_name_tips: '請輸入儀表板名稱',
    name: '名稱',
    apply_template: '應用模板',
    enter_template_name_tips: '搜索模板名稱',
    pic_adaptation: '適應組件',
    pic_equiratio: '等比適應',
    pic_original: '原始尺寸',
    pic_size: '圖片尺寸',
    web_addr: '網頁地址',
    stream_media_info: '流媒體信息',
    video_info: '視頻信息',
    title_position: '標題位置',
    tab_inner_style: 'tab內部樣式',
    data_format: '日期格式',
    border_color: '邊框顏色',
    theme_change_warn: '主題更換',
    theme_change_tips: '更換主題將會覆蓋視圖相關主題屬性建議提前備份,是否繼續更換？',
    theme_color_change_warn: '主題色更換',
    theme_color_change_tips: '主題色變更將會覆蓋原有視圖屬性',
    theme_color: '主題色',
    theme_color_dark: '深色',
    theme_color_light: '淺色',
    refresh_frequency: '刷新頻率',
    card_color_matching: '卡片配色',
    table_color_matching: '表格配色',
    background_color: '背景顏色',
    more: '更多',
    level: '層級',
    enlarge: '放大',
    panel_style: '儀表板樣式',
    multiplexing: '復用',
    panel_off: '儀表板已下架',
    batch_opt: '批量操作',
    edit_leave_tips: '是否放棄編輯離開當前界面？',
    hyperlinks: '超鏈接',
    is_live: '是否直播',
    yes: '是',
    no: '否',
    live_tips: '優先HTTPS鏈接',
    stream_media_add_tips: '添加流媒體信息...',
    stream_mobile_tips: 'IOS終端可能無法顯示',
    json_params_error: '第三方參數解析失敗，請檢查參數格式是否正確',
    inner_padding: '內邊距',
    board_radio: '邊框半徑',
    background: '背景',
    component_style: '組件樣式',
    web_set_tips: '部分網站可能設置不允許嵌入而無法顯示',
    repeat_params: '存在名稱重復的參數',
    enable_outer_param_set: '啟用外部參數設置',
    select_param: '請選擇參數...',
    add_param_link_field: '添加參數聯動字段',
    add_param: '添加參數',
    enable_param: '啟用參數',
    param_name: '參數名稱',
    outer_param_set: '外部參數設置',
    outer_param_decode_error: '外部參數解析錯誤未生效，請按規定編碼方式傳參',
    input_param_name: '請輸入參數名稱',
    params_setting: '外部參數設置',
    template_view_tips: '當前是模板視圖,請點擊更換數據集',
    edit_web_tips: '編輯狀態不可操作網頁內部',
    no_auth_role: '未分享角色',
    auth_role: '已分享角色',
    picture_limit: '只能插入圖片',
    drag_here: '請將左側字段拖至此處',
    copy_link_passwd: '複製鏈接及密碼',
    copy_link: '複製鏈接',
    copy_short_link: '複製短鏈接',
    copy_short_link_passwd: '複製短鏈接及密碼',
    passwd_protect: '密碼保護',
    link: '鏈接',
    over_time: '有效期',
    link_expire: '鏈接已過期！',
    link_share: '鏈接分享',
    link_share_desc: '開啓鏈接後，任何人可通過此鏈接訪問儀表闆。',
    share: '分享',
    remove_share_confirm: '確認取消當前儀表闆所有分享？',
    share_in: '分享給我',
    share_out: '我分享的',
    who_share: '分享人',
    when_share: '分享時間',
    share_to: '分享對象',
    share_to_some: '把[{some}]分享給',
    org: '組織',
    role: '角色',
    user: '用戶',
    datalist: '視圖列表',
    group: '目錄',
    panel: '儀表闆',
    panel_list: '儀表闆',
    groupAdd: '新建目錄',
    panelAdd: '新建儀表闆',
    delete: '刪除',
    move_to: '移動到',
    rename: '重命名',
    import: '導入模闆',
    tips: '提示',
    confirm_delete: '確認刪除',
    delete_success: '刪除成功',
    confirm: '確認',
    cancel: '取消',
    search: '搜索',
    back: '返回',
    view: '視圖',
    module: '組件',
    filter_module: '過濾組件',
    select_by_module: '按組件選擇',
    edit: '編輯',
    sys_template: '繫統模闆',
    user_template: '用戶模闆',
    add_category: '添加分類',
    add_app_category: '添加應用分類',
    filter_keywords: '輸入關鍵字進行過濾',
    dashboard_theme: '儀表闆主題',
    table: '表格',
    gap: '有間隙',
    no_gap: '無間隙',
    component_gap: '組件間隙',
    refresh_time: '刷新時間',
    minute: '分鐘',
    second: '秒',
    photo: '圖片',
    default_panel: '默認儀表闆',
    create_public_links: '創建公共鏈接',
    to_default: '另存爲默認',
    to_default_panel: '另存爲默認儀表闆',
    store: '收藏',
    save_to_panel: '保存爲模闆',
    export_to_panel: '導出爲模闆',
    export_to_pdf: '導出爲PDF',
    export_to_img: '導出爲圖片',
    export_to_app: '導出爲應用',
    preview: '預覽',
    fullscreen_preview: '全屏預覽',
    new_tab_preview: '新Tab頁預覽',
    select_panel_from_left: '請從左側選擇儀表闆',
    template_name: '模闆名稱',
    template: '模闆',
    category: '分類',
    all_org: '所有組織',
    custom: '自定義',
    import_template: '導入模闆',
    copy_template: '複用模闆',
    upload_template: '上傳模闆',
    belong_to_category: '所屬類別',
    pls_select_belong_to_category: '請選擇所屬類別',
    template_name_cannot_be_empty: '模闆名稱不能爲空',
    select_by_table: '按表選擇',
    data_list: '數據列表',
    component_list: '組件列表',
    custom_scope: '控製範圍',
    binding_parameters: '參數',
    multiple_choice: '多選',
    show_time: '顯示時間',
    single_choice: '單選',
    field: '字段',
    unshared_people: '未分享人員',
    shared_people: '已分享人員',
    error_data: '獲取數據出錯，請聯繫管理員',
    canvas_size: '畫佈大小',
    canvas_scale: '畫佈比例',
    style: '樣式',
    clean_canvas: '清空畫佈',
    insert_picture: '插入圖片',
    redo: '重做',
    undo: '撤銷',
    panelNull: '這是個空的儀表闆，可以通過編輯來豐富內容',
    copy: '複製',
    paste: '黏貼',
    cut: '剪切',
    lock: '鎖定',
    topComponent: '置頂',
    bottomComponent: '置底',
    upComponent: '上移',
    downComponent: '下移',
    linkage_setting: '聯動設置',
    add_tab: '新增Tab',
    open_aided_design: '打開組件輔助設計',
    close_aided_design: '關閉組件輔助設計',
    open_style_design: '打開樣式設計',
    close_style_design: '關閉樣式設計',
    matrix_design: '矩陣設計',
    left: 'x 坐標',
    top: 'y 坐標',
    height: '高',
    width: '寬',
    color: '顔色',
    backgroundColor: '背景色',
    borderStyle: '邊框風格',
    borderWidth: '邊框寬度',
    borderColor: '邊框顔色',
    borderRadius: '邊框半徑',
    fontSize: '字體大小',
    fontWeight: '字體粗細',
    lineHeight: '行高',
    letterSpacing: '字間距',
    padding: '內間距',
    margin: '外間距',
    textAlign: '左右對齊',
    opacity: '不透明度',
    verticalAlign: '上下對齊',
    text_align_left: '左對齊',
    text_align_center: '左右居中',
    text_align_right: '右對齊',
    vertical_align_top: '上對齊',
    vertical_align_middle: '居中對齊',
    vertical_align_bottom: '下對齊',
    border_style_solid: '實線',
    border_style_dashed: '虛線',
    select_component: '請選擇組件',
    other_module: '其他',
    content: '內容',
    default_panel_name: '默認儀表闆名稱',
    source_panel_name: '原儀表闆名稱',
    content_style: '內容樣式',
    canvas_self_adaption: '自適應畫佈區域',
    panel_save_tips: '儀表闆已變動，是否保存？',
    panel_save_warn_tips: '如果未保存，妳對儀表闆做的變更將會丟失！',
    do_not_save: '不保存',
    save: '保存',
    drill: '下鑽',
    linkage: '聯動',
    jump: '跳轉',
    cancel_linkage: '取消聯動',
    switch_picture: '更換圖片',
    select_field: '選擇視圖字段',
    remove_all_linkage: '清除所有聯動',
    exit_un_march_linkage_field: '存在未匹配聯動關繫的字段',
    details: '詳情',
    setting: '設置',
    no_drill_field: '缺少關聯字段',
    matrix: '矩陣',
    suspension: '懸浮',
    new_element_distribution: '元素移入分佈方式',
    aided_grid: '輔助設計網格',
    aided_grid_open: '打開',
    aided_grid_close: '關閉',
    export_pdf_page: '分頁線',
    export_pdf_page_remark: '僅對API導出儀表板PDF分頁有效',
    subject_no_edit: '繫統主題不能修改',
    subject_name_not_null: '主題名稱需要1~20字符',
    is_enable: '是否啟用',
    open_mode: '打開方式',
    new_window: '新窗口',
    now_window: '當前窗口',
    hyperLinks: '目標地址',
    link_open_tips: '儀表闆非編輯狀態可打開鏈接',
    data_loading: '數據準備中...',
    export_loading: '導出中...',
    export_pdf: '導出PDF',
    jump_set: '跳轉設置',
    enable_jump: '啟用跳轉',
    column_name: '字段名稱',
    enable_column: '啟用字段',
    open_model: '打開方式',
    link_type: '鏈接類型',
    link_outer: '外部鏈接',
    link_panel: '儀表闆',
    select_jump_panel: '選擇關聯的儀表闆',
    link_view: '聯動視圖',
    link_view_field: '聯動視圖字段',
    add_jump_field: '追加跳轉聯動依賴字段',
    input_jump_link: '請輸入跳轉連接',
    select_dimension: '請選擇維度...',
    please_select: '請選擇',
    video_type: '視頻類型',
    online_video: '在線視頻',
    streaming_media: '流媒體',
    auto_play: '自動播放',
    video_tips: '優先HTTPS鏈接；當前支持格式mp4,webm',
    play_frequency: '播放頻率',
    play_once: '播放一次',
    play_circle: '循環播放',
    video_links: '視頻鏈接',
    web_url: '網頁地址',
    video_add_tips: '添加視頻信息...',
    link_add_tips_pre: '請點擊上方',
    web_add_tips_suf: '添加網頁信息...',
    panel_view_result_show: '視圖結果',
    panel_view_result_tips: '選擇儀表闆會覆蓋視圖的結果展示數量，取值範圍1~10000',
    timeout_refresh: '請求超時，稍後刷新...',
    mobile_layout: '移動端佈局',
    component_hidden: '隱藏的組件',
    public_link_tips: '當前是公共鏈接模式，目標儀表闆未設置公共鏈接，無法跳轉',
    input_title: '請輸入標題',
    show_title: '標題',
    default_settings: '默認值設置',
    choose_background: '選擇組件背景',
    choose_background_tips: '組件自有背景會覆蓋當前設置',
    setting_background: '設置背景',
    setting_jump: '跳轉設置',
    select_view: '請選擇視圖...',
    visual: '虛擬化',
    prohibit_multiple: '禁止同數據集多字段',
    be_empty_dir: '是空目錄',
    fold: '收起',
    expand: '展開',
    pdf_export: 'PDF 導出',
    switch_pdf_template: '切換 PDF 模板'
  },
  plugin: {
    local_install: '本地安裝',
    remote_install: '遠程安裝',
    name: '插件名稱',
    free: '是否免費',
    cost: '費用',
    descript: '描述',
    version: '版本',
    creator: '作者',
    install_time: '安裝時間',
    release_time: '時間',
    un_install: '卸載(重啟服務後生效)',
    uninstall_confirm: '確定卸載該插件',
    uninstall_cancel: '取消卸載插件',
    un_install_success: '卸載成功，重啟生效',
    un_install_error: '卸載失敗，請聯系管理員'
  },
  display: {
    favicon: '系統圖標',
    logo: '頭部繫統logo',
    loginLogo: '登錄頁面頭部logo',
    loginImage: '登錄頁面右側圖片',
    loginTitle: '登錄頁面標題',
    title: '繫統名稱',
    advice_size: '建議圖片大小',
    theme: '主題顔色',
    topMenuColor: '頭部背景',
    topMenuActiveColor: '頭部選中背景',
    topMenuTextColor: '頭部字體顔色',
    topMenuTextActiveColor: '頭部字體選中顔色',
    themeLight: '淺色',
    themeDark: '深色',
    themeCustom: '自定義',
    openHomePage: '顯示首頁',
    openMarketPage: '顯示模板市場',
    mobileBG: '移動端登錄頁背景',
    helpLink: '幫助文檔鏈接',
    homeLink: '首頁鏈接',
    defaultHomeLink: '默認為系統內置首頁',
    showFoot: '顯示登錄頁腳',
    footContent: '頁腳內容',
    webFormat: '請輸入以[https://或http://]開頭的正確網址'
  },
  auth: {
    no_item_selected: '請在左側選擇組織、角色或用戶',
    no_resource_selected: '請在左側選擇資源',
    search_pre: '通過',
    search_suf: '名稱來搜索',
    separate_auth: '單獨授權',
    auth_extent_tips: '繼承自以下組織或角色的權限:',
    authConfig: '按用戶配置權限',
    sourceConfig: '按資源配置權限',
    authQuickConfig: '權限快捷配置',
    dept: '組織',
    role: '角色',
    user: '用戶',
    set_rules: '設置規則',
    sysParams: '系統變量',
    sysParams_type: {
      user_id: '用戶ID',
      user_name: '用戶名',
      user_source: '用戶來源',
      user_email: '郵箱',
      dept: '組織',
      role: '角色'
    },
    linkAuth: '數據源',
    datasetAuth: '數據集',
    chartAuth: '視圖',
    panelAuth: '儀表闆',
    menuAuth: '菜單和操作',
    deptHead: '所有組織',
    roleHead: '所有角色',
    userHead: '所有用戶',
    linkAuthHead: '所有數據源',
    datasetAuthHead: '所有數據集',
    chartAuthHead: '所有視圖',
    panelAuthHead: '所有儀表闆',
    menuAuthHead: '所有菜單和操作',
    view: '查看',
    use: '使用',
    export: '導出',
    manage: '管理',
    row_column: '行列權限設置',
    row_permission: '行權限規則',
    enable_row: '啟用行權限',
    white_list: '白名單',
    white_user_not: '以上權限規則對白名單用戶不生效',
    organization_or_role: '請選擇組織或角色',
    column_permission: '列權限規則',
    enable_column: '啟用列權限',
    search_by_field: '通過字段名稱搜索',
    add_condition: '添加條件',
    add_relationship: '添加關系',
    filter_fields: '篩選字段',
    selct_filter_fields: '請選擇篩選字段',
    enter_keywords: '請輸關鍵字',
    screen_method: '篩選方式',
    select: '請選擇',
    fixed_value: '固定值',
    default_method: '默認條件',
    select_all: '全 選',
    added: '已添加',
    manual_input: '手工輸入',
    please_fill: '請一行填一個，最多添加500個,識別錄入時會自動過濾重復的選項和已經添加過的選項',
    close: '關 閉',
    add: '添 加',
    sure: '確 定'
  },
  about: {
    auth_to: '授權給',
    invalid_license: 'License 無效',
    update_license: '更新 License',
    expiration_time: '過期時間',
    expirationed: '(已過期)',
    auth_num: '授權數量',
    version: '版本',
    version_num: '版本號',
    standard: '標準版',
    enterprise: '企業版',
    support: '獲取技術支持',
    update_success: '更新成功',
    serial_no: '序列號',
    remark: '備註'
  },
  template: {
    exit_same_template_check: '當前分類存在相同名稱模闆，是否覆蓋？',
    override: '覆蓋',
    cancel: '取消',
    confirm_upload: '上傳確認'
  },
  cron: {
    second: '秒',
    minute: '分',
    hour: '時',
    day: '日',
    minute_default: '分 (執行時間：0秒)',
    hour_default: '時 (執行時間：0分0秒)',
    day_default: '日 (執行時間：0時0分0秒)',
    month: '月',
    week: '周',
    year: '年',
    d_w_cant_not_set: '日期與星期不可以同時爲「不指定」',
    d_w_must_one_set: '日期與星期必須有一個爲「不指定」',
    every_day: '每日',
    cycle: '周期',
    not_set: '不指定',
    from: '從',
    to: '至',
    repeat: '循環',
    day_begin: '日開始，每',
    day_exec: '日執行一次',
    work_day: '工作日',
    this_month: '本月',
    day_near_work_day: '號，最近的工作日',
    this_week_last_day: '本月最後一天',
    set: '指定',
    every_hour: '每時',
    hour_begin: '時開始，每',
    hour_exec: '時執行一次',
    every_month: '每月',
    month_begin: '月開始，每',
    month_exec: '月執行一次',
    every: '每',
    every_begin: '開始，每',
    every_exec: '執行一次',
    every_week: '每周',
    week_start: '從星期',
    week_end: '至星期',
    every_year: '每年',
    week_tips: '說明：1-7 分別對應 周日-周六',
    minute_limit: '分鍾不能小於1，大於59',
    hour_limit: '小時不能小於1，大於23',
    day_limit: '天不能小於1，大於31'
  },
  dept: {
    can_not_move_change_sort: '不能移動以改變排序',
    can_not_move_parent_to_children: '父組織不能移動到自己的子節點下',
    move_success: '移動成功',
    name_exist_pre: '下已存在名稱爲【',
    name_exist_suf: '】的組織',
    root_org: '頂層組織'
  },
  webmsg: {
    web_msg: '站內消息通知',
    show_more: '查看更多',
    all_type: '全部類型',
    panel_type: '儀表闆分享',
    dataset_type: '數據集同步',
    content: '消息內容',
    sned_time: '提交時間',
    read_time: '查看時間',
    type: '消息類型',
    mark_read: '標記已讀',
    all_mark_read: '全部已讀',
    please_select: '請至少選擇一條消息',
    mark_success: '標記已讀成功',
    receive_manage: '接收管理',
    i18n_msg_type_panel_share: '儀表闆分享',
    i18n_msg_type_panel_share_cacnel: '儀表闆取消分享',
    i18n_msg_type_dataset_sync: '數據集同步',
    i18n_msg_type_dataset_sync_success: '數據集同步成功',
    i18n_msg_type_dataset_sync_failed: '數據集同步失敗',
    i18n_msg_type_ds_invalid: '數據源失效',
    i18n_msg_type_all: '全部類型',
    channel_inner_msg: '站內消息',
    channel_email_msg: '郵件提醒',
    channel_wecom_msg: '企業微信',
    channel_dingtalk_msg: '釘釘提醒',
    channel_lark_msg: '飛書提醒',
    channel_larksuite_msg: '國際飛書'
  },
  denumberrange: {
    label: '數值區間',
    split_placeholder: '至',
    please_key_min: '請輸入最小值',
    please_key_max: '請輸入最大值',
    out_of_min: '最小值不能小於最小整數-2³²',
    out_of_max: '最大值不能大於最大整數2³²-1',
    must_int: '請輸入整數',
    min_out_max: '最小值必須小於最大值',
    max_out_min: '最大值必須大於最小值'
  },
  desearchbutton: {
    label: '查詢按鈕',
    text: '名稱',
    auto_trigger: '自動觸發',
    range: '控製範圍',
    relative: '關聯組件',
    auto_trigger_tip: '進入預覽頁面自動觸發一次',
    range_tip: '默認關聯全部過濾組件'
  },
  desresetbutton: {
    label: '清空按鈕',
    reset: '重置按鈕',
    text: '名稱'
  },
  denumberselect: {
    label: '數字下拉',
    placeholder: '請選擇數字'
  },
  deinputsearch: {
    label: '文本搜索',
    placeholder: '請輸入關鍵字'
  },
  detextselect: {
    label: '文本下拉',
    placeholder: '請選擇文本'
  },
  detextselectTree: {
    label: '下拉樹',
    placeholder: '請選擇'
  },
  detextgridselect: {
    label: '文本列表',
    placeholder: '請選擇'
  },
  denumbergridselect: {
    label: '數字列表',
    placeholder: '請選擇'
  },
  dedaterange: {
    label: '日期範圍',
    to_placeholder: '結束日期',
    from_placeholder: '開始日期',
    split_placeholder: '至'
  },
  dedate: {
    label: '日期',
    placeholder: '請選擇日期'
  },
  deyearmonth: {
    label: '年月',
    placeholder: '請選擇年月'
  },
  deyear: {
    label: '年份',
    placeholder: '請選擇年份'
  },
  deshowdate: {
    label: '時間',
    show_week: '顯示星期',
    show_date: '顯示日期',
    time_format: '時間格式',
    date_format: '日期格式',
    custom: '自定義格式',
    open_mode: '展示風格',
    m_default: '簡單風格',
    m_elec: '電子時鐘',
    m_simple: '簡單表盤',
    m_complex: '複雜表盤',
    select_openMode: '請選擇展示風格',
    select_time_format: '請選擇時間各式',
    select_date_format: '請選擇日期格式'

  },
  xpacktask: {
    add: '新增任務',
    edit: '編輯任務',
    task_id: '任務ID',
    name: '任務名稱',
    last_exec_time: '上次執行時間',
    last_exec_status: '上次執行狀態',
    ready: '就緒',
    success: '成功',
    underway: '執行中',
    error: '失敗',
    creator: '創建人',
    create_time: '創建時間',
    search_by_name: '根據名稱搜索',
    exec_time: '執行時間',
    status: '執行狀態',
    task_status: '任務狀態',
    running: '運行中',
    stopped: '已停止',
    start: '啟用',
    start_success: '啟用成功',
    start_success_but: '，但任務過期，請手動更改結束時間',
    sure_batch_delete: '確定批量刪除任務嗎？',
    pixel_error: '分辨率支持{800 - 10000} * {500 - 6250}',
    next_exec_time: '下次執行時間'

  },
  emailtask: {
    week_mon: '周一',
    week_tue: '周二',
    week_wed: '周三',
    week_thu: '周四',
    week_fri: '周五',
    week_sat: '周六',
    week_sun: '周日',
    send_config: '發送設置',
    title: '報告主題',
    panel: '儀表闆',
    content: '報告正文',
    recipients: '收件人',
    recisetting: '接收設置',
    email: '郵件',
    wecom: '企業微信',
    dingtalk: '釘釘',
    lark: '飛書',
    larksuite: '國際飛書',
    pixel: '分辨率',
    default: '默認',
    custom: '自定義',
    rate_type: '發送p頻率',
    cron_exp: 'cron表達式',
    exec_time: '執行時間',
    start_time: '開始時間',
    end_time: '結束時間',
    chart_data: '視圖數據',
    panel_preview: '預覽報告',
    preview: '預覽',
    emial_preview: '報告預覽',
    chart_data_range: '視圖數據範圍',
    simple_repeat: '簡單重複',
    once_a_day: '每天',
    once_a_week: '每周',
    once_a_month: '每月',
    complex_repeat: '複雜重複',
    pixel_tip: '可直接輸入分辨率(例如:2560 * 1600)或者選擇',
    task_type: '任務類型',
    range_view: '展示數據',
    range_all: '全部數據',
    execute_now: '立即執行',
    fire_now_success: '任務發起成功'
  },
  dynamic_time: {
    set_default: '設置默認值',
    fix: '固定時間',
    dynamic: '動態時間',
    relative: '相對當前',
    today: '今天',
    yesterday: '昨天',
    firstOfMonth: '月初',
    firstOfYear: '年初',
    custom: '自定義',
    date: '日',
    week: '周',
    month: '月',
    year: '年',
    before: '前',
    after: '後',
    preview: '預覽',
    set: '設置',

    cweek: '本周',
    lweek: '上周',
    cmonth: '本月',
    cquarter: '本季',
    lquarter: '上季',
    cyear: '本年'
  },
  dynamic_year: {
    fix: '固定年份',
    dynamic: '動態年份',
    current: '今年',
    last: '去年'
  },
  dynamic_month: {
    fix: '固定年月',
    dynamic: '動態年月',
    current: '本月',
    last: '上月',
    firstOfYear: '當年首月',
    sameMonthLastYear: '去年同月'
  },
  wizard: {
    welcome_title: '歡迎使用DataEase',
    welcome_hint: '人人可用的開源數據可視化分析工具',
    demo_video: '演示視頻',
    quick_start: '快速入門',
    online_document: '在線文檔',
    latest_developments: '最新動態',
    teaching_video: '教學視頻',
    enterprise_edition: '企業版',
    contact_us: '聯繫我們',
    demo_video_hint: '如何3分鐘製作一個DataEase數據看闆、並分享給他人',
    online_document_hint: '涵蓋DataEase的安裝步驟、用戶手冊、使用教程、常見問題的解決方案、以及二次開發等',
    teaching_video_bottom_hint: '更多視頻資料',
    enterprise_edition_hint1: '提供企業級應用場景X-Pack增強包',
    enterprise_edition_hint2: '提供高等級原廠服務支持',
    enterprise_edition_hint3: '提供DataEase最佳實踐建議',
    open_source_community: '開源社區',
    click_show: '點擊查看',
    show_more: '查看更多',
    click_inner: '點擊進入',
    email: '郵箱：',
    tel: '電話：',
    web: '網址：',
    apply: '免費試用申請',
    more: '更多',
    weChat_official_account: '微信公眾號',
    technical_group: '技術交流群',
    f2c_train: '飛致雲認證'
  },
  kettle: {
    add: '添加 Kettle 服務',
    status: '狀態',
    carte: 'Kettle 地址',
    port: '端口',
    user: '用戶名',
    passwd: '密碼'
  },
  log: {
    title: '操作日誌',
    optype: '操作類型',
    detail: '操作詳情',
    user: '操作用戶',
    time: '操作時間',
    export: '導出',
    export_as: '導出为',
    confirm: '確定導出嗎？',
    search_by_key: '搜索詳情',
    ip: 'IP地址'
  },
  plugin_style: {
    border: '邊框'
  },
  sql_variable: {
    variable_mgm: '參數設置'
  },
  map_setting: {
    area_level: '區域等級',
    area_code: '區域代碼',
    please_input: '請填寫',
    parent_area: '上級區域',
    area_code_tip: '區域代碼格式為9位數字',
    area_name: '區域名稱',
    parent_name: '上級區域',
    geo_json: '坐標文件',
    fileplaceholder: '請上傳json格式坐標文件',
    delete_confirm: '及子節點都會被刪除，確認執行？',
    cur_node: '當前節點'
  },
  map_mapping: {
    map: '圖形',
    attr: '屬性',
    empty: '無數據',
    please_select_map: '請先選擇地圖範圍'
  },
  'I18N_USER_TEMPLATE_ERROR': '模版錯誤',
  'i18n_max_user_import_size': '文件最大不能超過10M',
  app_template: {
    move: '移動',
    move_item: '移動應用',
    datasource_new: '新建',
    datasource_history: '復用',
    datasource_from: '數據來源',
    apply_template: '應用模版',
    execution_time: '执行时间',
    app_manager: '應用管理',
    app_upload: '上傳應用',
    no_apps: '暫無應用',
    app_group_icon: '封面圖標',
    app_name: '應用名稱',
    search_by_keyword: '通過關鍵字搜索',
    apply_logs: '應用記錄',
    app_group_delete_tips: '確定刪除該應用分類嗎?',
    app_group_delete_content: '刪除後，該分類中所有的應用模板也將被刪除。',
    panel_position: '儀表板位置',
    panel_name: '儀表板名稱',
    dataset_group_position: '數據集分組位置',
    dataset_group_name: '數據集分組名稱',
    datasource_info: '數據源信息',
    datasource: '數據源',
    dataset_group: '數據集分組',
    panel: '儀表板',
    log_delete_tips: '確定刪除該條應用記錄嗎？',
    log_resource_delete_tips: '刪除相關資源（刪除後不可恢復）',
    file_error_tips: '未找到相關數據文件，當前文件可能不是DataEase應用文件，或者文件已經損壞',
    app_export: '應用導出',
    app_version: '應用版本',
    program_version: 'DataEase最低版本',
    creator: '作者',
    export: '導出'
  },

  logout: {
    oidc_logout_error: 'OIDC退出失敗，是否繼續退出DataEase？',
    cas_logout_error: 'CAS服務異常，請聯系管理員！'
  },
  watermark: {
    support_params: '當前支持的參數：',
    enable: '啟用水印',
    enable_panel_custom: '允許儀表板單獨打開或者關閉水印',
    content: '水印內容',
    custom_content: '自定義公式',
    account: '賬號',
    nick_name: '昵稱',
    ip: 'IP',
    now: '當前時間',
    watermark_color: '水印顏色',
    watermark_font_size: '水印字號',
    watermark_space: '水印間距',
    horizontal: '橫向間距',
    vertical: '縱向間距',
    reset: '重置',
    preview: '預覽',
    save: '保存'
  }
}
